// All character data verified via Jikan API (api.jikan.moe)
// Descriptions sourced from ComicVine + canon verification

const characterProfiles = [
  {
    slug: 'monkey-d-luffy',
    name: 'Monkey D. Luffy',
    aliases: ['Straw Hat', 'Mugiwara', 'Fifth Emperor', 'Joy Boy'],
    crew: 'Straw Hat Pirates',
    role: 'Captain',
    devilFruit: 'Gomu Gomu no Mi (Hito Hito no Mi, Model: Nika)',
    devilFruitType: 'Mythical Zoan',
    bounty: '3,000,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/9/310307.jpg',
    bio: "The captain of the Straw Hat Pirates. His dream is to find the legendary One Piece and become the Pirate King. Despite his naive attitude, he is an incredible leader whom the Straw Hats proudly follow into any fight. He ate his Devil Fruit as a kid, thinking it was a snack. It turned out to be the most sought-after fruit in the world — the Hito Hito no Mi, Model: Nika, a Mythical Zoan tied to the Sun God. The World Government hid its real name for over 800 years.",
    details: [
      "Son of Monkey D. Dragon, leader of the Revolutionary Army",
      "Grandson of Monkey D. Garp, the Hero of the Marines",
      "Sworn brothers with Portgas D. Ace and Sabo",
      "Inspired to become a pirate by Red-Haired Shanks",
      "Gear Second, Third, Fourth (Boundman, Snakeman, Tankman) and Gear Fifth",
      "Gear Fifth awakening turns everything around him rubbery, including the ground and people",
      "Defeated Crocodile, Rob Lucci, Doflamingo, Katakuri, and Kaido",
      "One of the Four Emperors after the Wano arc"
    ]
  },
  {
    slug: 'roronoa-zoro',
    name: 'Roronoa Zoro',
    aliases: ['Pirate Hunter', 'Marimo', 'King of Hell'],
    crew: 'Straw Hat Pirates',
    role: 'First Mate / Swordsman',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: '1,111,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/3/100534.jpg',
    bio: "The swordsman, first member, and Vice Captain of the Straw Hat Pirates. Uses the Santoryu (Three Sword Style) of sword combat — one in each hand, one in his mouth. He aims to become the world's greatest swordsman by defeating Dracule Mihawk. He is one of the eleven supernova rookies of the Worst Generation of pirates. Infamous for having zero sense of direction.",
    details: [
      "First crew member Luffy recruited, in Shells Town",
      "Bounty of 1,111,000,000 berries",
      "Current swords: Wado Ichimonji, Sandai Kitetsu, and Enma",
      "Enma was previously owned by Kozuki Oden and drains its wielder's Haki",
      "Trained by Mihawk during the two-year timeskip",
      "Unlocked Advanced Conqueror's Haki during the raid on Onigashima",
      "Defeated King the Wildfire, one of Kaido's top three commanders"
    ]
  },
  {
    slug: 'nami',
    name: 'Nami',
    aliases: ['Cat Burglar'],
    crew: 'Straw Hat Pirates',
    role: 'Navigator',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: '366,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/6/59914.jpg',
    bio: "The navigator of the Straw Hat Pirates and a skilled cartographer. A lover of money and mikans who dreams of making a map of the entire world. She joined after Luffy destroyed Arlong Park and freed her village from the fishman's tyranny. She uses the Clima-Tact, a weather-manipulating staff built by Usopp and later upgraded by Franky and the Weatheria scientists.",
    details: [
      "Orphaned as a baby, adopted by Bell-mere in Cocoyama Village",
      "Forced to work as Arlong's cartographer for years to buy her village's freedom",
      "Bounty of 366,000,000 berries",
      "Clima-Tact lets her create thunder clouds, mirages, and lightning strikes",
      "Zeus, a living thundercloud that used to belong to Big Mom, now lives inside her weapon"
    ]
  },
  {
    slug: 'usopp',
    name: 'Usopp',
    aliases: ['Sogeking', 'God Usopp', 'King of Snipers'],
    crew: 'Straw Hat Pirates',
    role: 'Sniper',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: '500,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/16/188076.jpg',
    bio: "The sniper of the Straw Hat Pirates, famous for frequently lying. He wants to be a great warrior of the sea. Son of Yasopp, a sharpshooter in Red-Haired Shanks's crew. Despite being one of the physically weakest members, his sharpshooting and inventions have saved the crew multiple times.",
    details: [
      "Joined the crew in Syrup Village",
      "Created the alter ego 'Sogeking' during Enies Lobby",
      "Earned the name 'God Usopp' at Dressrosa after accidentally rallying the gladiators",
      "Uses Kuro Kabuto slingshot with Pop Green ammunition that grows into plants on impact",
      "Awakened Observation Haki at Dressrosa",
      "Bounty of 500,000,000 berries"
    ]
  },
  {
    slug: 'vinsmoke-sanji',
    name: 'Vinsmoke Sanji',
    aliases: ['Black Leg', 'Mr. Prince', 'Stealth Black'],
    crew: 'Straw Hat Pirates',
    role: 'Cook',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: '1,032,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/5/136769.jpg',
    bio: "The cook of the Straw Hat Pirates and lover of all things women. His dream is to find the All Blue, a legendary ocean where fish from all four seas live. He fights only with his legs — the Black Leg Style — to keep his hands safe for cooking. Raised by the pirate chef Zeff at the Baratie restaurant after they were stranded together on a rock for 85 days.",
    details: [
      "Born a prince of the Vinsmoke Family, a lineage of genetically modified assassins",
      "His mother Sora took a drug to keep his emotions intact, making him the 'failure' of the family",
      "Bounty of 1,032,000,000 berries",
      "Diable Jambe: spins so fast his leg catches fire",
      "Ifrit Jambe: even stronger flame technique after his Germa genes awakened in Wano",
      "Gained an exoskeleton and enhanced durability after his latent Germa modifications activated"
    ]
  },
  {
    slug: 'tony-tony-chopper',
    name: 'Tony Tony Chopper',
    aliases: ['Cotton Candy Lover', 'Tanuki'],
    crew: 'Straw Hat Pirates',
    role: 'Doctor',
    devilFruit: 'Hito Hito no Mi (Human-Human Fruit)',
    devilFruitType: 'Zoan',
    bounty: '1,000',
    image: 'https://cdn.myanimelist.net/images/characters/3/100536.jpg',
    bio: "The doctor of the Straw Hat Pirates. He was a normal reindeer until he ate the Human-Human Fruit, which allows him to talk and transform. His dream is to become a doctor who can cure any disease. The World Government thinks he is the crew's pet, which is why his bounty is 1,000 berries — a running joke throughout the series.",
    details: [
      "Joined the crew on Drum Island after his mentor Doctor Hiriluk died",
      "Can transform between seven forms using Rumble Balls",
      "Monster Point gives him a giant berserker form",
      "Developed a universal antidote during the Udon prison arc in Wano",
      "Bounty of 1,000 berries (the lowest known bounty in the series)"
    ]
  },
  {
    slug: 'nico-robin',
    name: 'Nico Robin',
    aliases: ['Devil Child', 'Light of the Revolution', 'Miss All Sunday'],
    crew: 'Straw Hat Pirates',
    role: 'Archaeologist',
    devilFruit: 'Hana Hana no Mi (Flower-Flower Fruit)',
    devilFruitType: 'Paramecia',
    bounty: '930,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/16/363700.jpg',
    bio: "The archaeologist of the Straw Hat Pirates, who has the powers of the Flower-Flower Devil Fruit. Once an officer of Crocodile's Baroque Works Organization under the name Miss All Sunday, Robin left them and joined the Straw Hats. She is the only person alive who can read the Poneglyphs — ancient stone records that reveal the True History the World Government wants erased.",
    details: [
      "Born on Ohara, an island of scholars destroyed by the World Government's Buster Call",
      "Has been hunted by the World Government since she was 8 years old",
      "Bounty of 930,000,000 berries — most of it because she can read Poneglyphs",
      "Can sprout copies of her limbs on any surface, and after the timeskip, full body clones",
      "Demonio Fleur: a giant dark demon form she revealed in Wano"
    ]
  },
  {
    slug: 'franky',
    name: 'Franky',
    aliases: ['Cyborg', 'Cutty Flam', 'Iron Man'],
    crew: 'Straw Hat Pirates',
    role: 'Shipwright',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: '394,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/13/210053.jpg',
    bio: "The shipwright of the Straw Hat Pirates and a self-made cyborg. He built the Thousand Sunny. He is a former disciple of Tom, a fishman shipwright who built the Oro Jackson (Gol D. Roger's ship) using the wood of the Treasure Tree Adam. His real name is Cutty Flam. He rebuilt his own body with cola-powered weapons after being hit by the sea train.",
    details: [
      "Built the Thousand Sunny from Treasure Tree Adam wood — the same wood used for Roger's ship",
      "Runs on cola (literally — his refrigerator chest is his power source)",
      "Bounty of 394,000,000 berries",
      "General Franky: a giant robot suit he built during the timeskip",
      "Radical Beam: a laser based on Vegapunk's Pacifista technology"
    ]
  },
  {
    slug: 'brook',
    name: 'Brook',
    aliases: ['Soul King', 'Dead Bones', 'Gentleman Skeleton'],
    crew: 'Straw Hat Pirates',
    role: 'Musician',
    devilFruit: 'Yomi Yomi no Mi (Revive-Revive Fruit)',
    devilFruitType: 'Paramecia',
    bounty: '383,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/10/161005.jpg',
    bio: "\"Soul King\" Brook is a member of the Straw Hat Pirates, serving as their musician. He ate the Revive-Revive Fruit, and is undead — having died and returned to life because of the fruit. By the time his soul found its body, only bones were left. He spent 50 years alone on a ghost ship in the Florian Triangle before the Straw Hats found him.",
    details: [
      "Originally part of the Rumbar Pirates who promised to return to Laboon, a whale at Reverse Mountain",
      "Became a famous rock star called 'Soul King' during the timeskip",
      "Bounty of 383,000,000 berries",
      "Can channel the cold of the underworld through his sword",
      "His soul can leave his body and move through walls",
      "Single-handedly got a copy of Big Mom's Road Poneglyph"
    ]
  },
  {
    slug: 'jinbe',
    name: 'Jinbe',
    aliases: ['Knight of the Sea', 'Boss Jinbe', 'First Son of the Sea'],
    crew: 'Straw Hat Pirates',
    role: 'Helmsman',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: '1,100,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/15/307148.jpg',
    bio: "A whale shark fish-man who was once a member of the Seven Warlords. He is the helmsman of the Straw Hat Pirates. He was the second captain of the Sun Pirates after Fisher Tiger died. The tenth and final crew member to join before the final saga.",
    details: [
      "Former Warlord of the Sea",
      "Bounty of 1,100,000,000 berries",
      "Fish-Man Karate lets him control water and strike opponents from the inside out",
      "Officially joined on Whole Cake Island and boarded the ship in Wano",
      "Carried Luffy to safety after Marineford when Luffy was broken by Ace's death"
    ]
  },
  {
    slug: 'shanks',
    name: 'Shanks',
    aliases: ['Red Hair'],
    crew: 'Red Hair Pirates',
    role: 'Captain, one of the Four Emperors',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: '4,048,900,000',
    image: 'https://cdn.myanimelist.net/images/characters/9/307639.jpg',
    bio: "The captain of the Red-Haired Pirates and one of the Four Emperors. He is the man who inspired Luffy to become a pirate and the original owner of the straw hat. He once apprenticed on Gol D. Roger's ship as a cabin boy alongside Buggy. He lost his left arm saving a young Luffy from a Sea King. The three scars on his face were given to him by Blackbeard.",
    details: [
      "Bounty of 4,048,900,000 berries",
      "Stopped the Marineford War by showing up and offering to fight anyone who wanted to continue",
      "One of the few characters who can use all three types of Haki",
      "His Conqueror's Haki is strong enough to damage physical objects at a distance",
      "Apprenticed on Roger's ship alongside Buggy the Clown"
    ]
  },
  {
    slug: 'trafalgar-law',
    name: 'Trafalgar D. Water Law',
    aliases: ['Surgeon of Death'],
    crew: 'Heart Pirates',
    role: 'Captain',
    devilFruit: 'Ope Ope no Mi (Op-Op Fruit)',
    devilFruitType: 'Paramecia',
    bounty: '3,000,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/10/258757.jpg',
    bio: "The captain of the Heart Pirates and one of the Eleven Supernovas. He ate the Op-Op Devil Fruit and can modify anything within his created area of effect called a Room. He is a rival and temporary ally for Luffy. He formed an alliance with the Straw Hats to take down Doflamingo and later Kaido.",
    details: [
      "Bounty of 3,000,000,000 berries",
      "From the destroyed kingdom of Flevance, which was poisoned by Amber Lead",
      "Saved by Donquixote Rosinante (Corazon), Doflamingo's brother",
      "The Op-Op Fruit can perform the Perennial Youth Operation — eternal youth at the cost of the user's life",
      "Defeated Big Mom alongside Eustass Kid in Wano"
    ]
  },
  {
    slug: 'buggy',
    name: 'Buggy the Clown',
    aliases: ['Buggy the Star Clown', 'The Genius Jester'],
    crew: 'Buggy Pirates / Cross Guild',
    role: 'Captain / Figurehead Emperor',
    devilFruit: 'Bara Bara no Mi (Chop-Chop Fruit)',
    devilFruitType: 'Paramecia',
    bounty: '3,189,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/6/69112.webp',
    bio: "A pirate captain who dresses as a clown. Buggy consumed the Bara Bara no Mi, which gave him the power to split his body into pieces but took away his ability to swim. He was an apprentice on Gol D. Roger's ship alongside Shanks. He has failed upward his entire career — from East Blue pirate to Impel Down escapee to Warlord to one of the Four Emperors.",
    details: [
      "Bounty of 3,189,000,000 berries (mostly because the world thinks he runs Cross Guild)",
      "Apprenticed on Roger's ship as a cabin boy alongside Shanks",
      "Lost his Devil Fruit ability to swim because Shanks startled him while he was eating it",
      "Figurehead of Cross Guild — Mihawk and Crocodile do the real work",
      "Somehow keeps getting promoted despite having no idea what he is doing"
    ]
  },
  {
    slug: 'portgas-d-ace',
    name: 'Portgas D. Ace',
    aliases: ['Fire Fist'],
    crew: 'Whitebeard Pirates',
    role: '2nd Division Commander',
    devilFruit: 'Mera Mera no Mi (Flame-Flame Fruit)',
    devilFruitType: 'Logia',
    bounty: '550,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/2/72220.jpg',
    bio: "The only son of Gol D. Roger, the Pirate King. Portgas D. Ace was a well-known and powerful pirate who served as the Second Division Commander of the Whitebeard Pirates. He ate the Flame-Flame Fruit. He was adopted by Monkey D. Garp and grew up as the sworn older brother of Monkey D. Luffy and Sabo.",
    details: [
      "Born as Gol D. Ace but took his mother Portgas D. Rouge's name",
      "His mother held him in her womb for 20 months to protect him from the World Government",
      "Bounty of 550,000,000 berries",
      "Killed at Marineford by Admiral Akainu while protecting Luffy",
      "After his death, the Mera Mera no Mi reappeared and was won by Sabo"
    ]
  },
  {
    slug: 'crocodile',
    name: 'Sir Crocodile',
    aliases: ['Mr. 0', 'Desert King'],
    crew: 'Cross Guild (formerly Baroque Works)',
    role: 'Co-founder of Cross Guild',
    devilFruit: 'Suna Suna no Mi (Sand-Sand Fruit)',
    devilFruitType: 'Logia',
    bounty: '1,965,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/6/100535.jpg',
    bio: "A former hero of Alabasta who secretly controlled and could turn into sand, as well as absorb moisture from any material. He was the mastermind behind Baroque Works, operating as Mr. 0, with Nico Robin as his partner. A former Warlord of the Sea. The long scar across his face is an injury from his fight with Whitebeard.",
    details: [
      "Bounty of 1,965,000,000 berries",
      "Main villain of the Alabasta arc — the first major saga villain Luffy defeated",
      "Later helped Luffy escape Impel Down and fought at Marineford",
      "Now a co-founder of Cross Guild alongside Mihawk and Buggy",
      "His hook hand hides a poison hook underneath"
    ]
  },
  {
    slug: 'donquixote-doflamingo',
    name: 'Donquixote Doflamingo',
    aliases: ['Joker', 'Heavenly Demon', 'Young Master'],
    crew: 'Donquixote Pirates',
    role: 'Captain / Former Warlord / Former King of Dressrosa',
    devilFruit: 'Ito Ito no Mi (String-String Fruit)',
    devilFruitType: 'Paramecia',
    bounty: '340,000,000 (frozen)',
    image: 'https://cdn.myanimelist.net/images/characters/5/349513.jpg',
    bio: "Captain of the Donquixote Pirates, former Warlord, former King of Dressrosa, and former World Noble. He was the underground's most influential broker under the alias \"Joker.\" His String-String Fruit lets him create razor-thin strings that cut through buildings, control people like puppets, and even repair internal organs. He is a major antagonist of the Marineford Arc and the main antagonist of the Dressrosa Arc.",
    details: [
      "Born a Celestial Dragon — his father left Mariejois, and they were hunted as fallen nobles",
      "Killed his own father and brought the head back to Mariejois, but was rejected",
      "Awakened his Devil Fruit, allowing him to turn his surroundings into strings",
      "Birdcage: created an inescapable cage of strings around all of Dressrosa",
      "Defeated by Luffy's Gear Fourth: Boundman",
      "Currently locked in Impel Down Level 6"
    ]
  },
  {
    slug: 'big-mom',
    name: 'Charlotte Linlin',
    aliases: ['Big Mom'],
    crew: 'Big Mom Pirates',
    role: 'Captain / Former Emperor',
    devilFruit: 'Soru Soru no Mi (Soul-Soul Fruit)',
    devilFruitType: 'Paramecia',
    bounty: '4,388,000,000',
    image: '/characters/big-mom.webp',
    bio: "Charlotte Linlin, known as Big Mom, is the captain of the Big Mom Pirates and queen of Whole Cake Island. She was one of the Four Emperors in the era before Luffy. Mother of 85 children who she uses to form political marriages. Her Soul-Soul Fruit lets her take lifespan from anyone who fears her and put souls into objects, creating an army of living homies.",
    details: [
      "Bounty of 4,388,000,000 berries",
      "Has 85 children and 43 husbands",
      "Her three main homies: Zeus (thundercloud), Prometheus (sun), Napoleon (hat/sword)",
      "Raised by Mother Carmel on Elbaf as a child — her past there is one of the darkest in the series",
      "Defeated in Wano by Trafalgar Law and Eustass Kid working together"
    ]
  },
  {
    slug: 'blackbeard',
    name: 'Marshall D. Teach',
    aliases: ['Blackbeard'],
    crew: 'Blackbeard Pirates',
    role: 'Admiral / Emperor',
    devilFruit: 'Yami Yami no Mi (Dark-Dark Fruit) + Gura Gura no Mi (Tremor-Tremor Fruit)',
    devilFruitType: 'Logia + Paramecia',
    bounty: '3,996,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/2/109536.jpg',
    bio: "Blackbeard is the Admiral of the Blackbeard Pirates and currently one of the Four Emperors. He was once a member of the Whitebeard Pirates and later a Warlord. He murdered his crewmate Thatch to steal the Yami Yami no Mi, then took Whitebeard's Gura Gura no Mi after his death at Marineford — becoming the only known person to wield two Devil Fruit powers.",
    details: [
      "Bounty of 3,996,000,000 berries",
      "Spent decades on Whitebeard's ship waiting for the Dark-Dark Fruit to appear",
      "Captured Ace and turned him in to the World Government, triggering the Marineford War",
      "The scar on Shanks's face was caused by Blackbeard",
      "Has a body that 'doesn't follow the normal rules' according to Marco — this may explain his two fruits"
    ]
  },
  {
    slug: 'smoker',
    name: 'Smoker',
    aliases: ['White Hunter', 'Smoker the White Hunter'],
    crew: 'Marines',
    role: 'Vice Admiral, G-5 Base Commander',
    devilFruit: 'Moku Moku no Mi (Smoke-Smoke Fruit)',
    devilFruitType: 'Logia',
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/5/235841.jpg',
    bio: "Smoker the White Hunter is a Marine Vice Admiral and Commander of the G-5 Marine Base. He has the powers of the Smoke-Smoke Fruit. He is a recurring adversary of Monkey D. Luffy and the Straw Hats — the first Marine to catch Luffy, and the first to lose him. He genuinely cares about justice rather than following corrupt orders.",
    details: [
      "Has chased Luffy since Loguetown, where Luffy was saved from execution by Dragon",
      "Commander of G-5, the roughest Marine base in the New World",
      "Fought alongside Luffy against Caesar Clown on Punk Hazard",
      "His body was swapped with Tashigi's by Trafalgar Law on Punk Hazard",
      "Uses a jitte (truncheon) tipped with Sea Prism Stone"
    ]
  },
  {
    slug: 'rob-lucci',
    name: 'Rob Lucci',
    aliases: ['Massacre Weapon'],
    crew: 'CP0 (formerly CP9)',
    role: 'Agent',
    devilFruit: 'Neko Neko no Mi, Model: Leopard (Cat-Cat Fruit)',
    devilFruitType: 'Zoan',
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/14/71509.jpg',
    bio: "Rob Lucci is the strongest member of Cipher Pol No. 9. On top of eating the Cat-Cat Fruit, Model: Leopard, he is a master of the Six Powers martial arts. After the timeskip, he is once again affiliated with the World Government and is now an official member of Cipher Pol Aigis Zero (CP0), and is now Spandam's superior.",
    details: [
      "Went undercover at Galley-La Company for five years to find Pluton's blueprints",
      "Always carries his pigeon Hattori, who he used as a ventriloquist dummy while undercover",
      "Main villain of the Enies Lobby arc — one of Luffy's hardest fights pre-timeskip",
      "Master of Rokushiki (Six Powers): Shigan, Rankyaku, Soru, Tekkai, Geppo, Kami-e",
      "His Awakened Zoan form was revealed during the Egghead arc"
    ]
  },
  {
    slug: 'dracule-mihawk',
    name: 'Dracule Mihawk',
    aliases: ['Hawk Eyes', 'World\'s Strongest Swordsman'],
    crew: 'Cross Guild (formerly solo)',
    role: 'Swordsman / Former Warlord',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: '3,590,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/7/69747.jpg',
    bio: "The greatest swordsman in the world and the man Roronoa Zoro must defeat. Former Warlord of the Sea who now serves as the real military power behind Cross Guild alongside Crocodile. Carries the black blade Yoru, one of the strongest swords in existence.",
    details: [
      "Bounty of 3,590,000,000 berries",
      "Trained Zoro during the two-year timeskip despite being his rival",
      "Can cut battleships and icebergs with a single slash",
      "Sailed alone before joining Cross Guild — he had no crew for years",
      "His blade Yoru is one of the 12 Supreme Grade swords"
    ]
  },
  {
    slug: 'boa-hancock',
    name: 'Boa Hancock',
    aliases: ['Pirate Empress', 'Snake Princess'],
    crew: 'Kuja Pirates',
    role: 'Captain / Former Warlord',
    devilFruit: 'Mero Mero no Mi (Love-Love Fruit)',
    devilFruitType: 'Paramecia',
    bounty: '1,659,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/14/146013.jpg',
    bio: "Captain of the Kuja Pirates and ruler of Amazon Lily. Her Love-Love Fruit turns anyone attracted to her into stone — and almost everyone is. A former slave of the Celestial Dragons who was freed by Fisher Tiger. One of the few characters openly in love with Luffy.",
    details: [
      "Bounty of 1,659,000,000 berries",
      "Only female Warlord of the Sea",
      "Former slave of the Celestial Dragons — forced-fed a Devil Fruit for entertainment",
      "Helped Luffy infiltrate Impel Down and later fought at Marineford",
      "All three Boa sisters (Hancock, Sandersonia, Marigold) have Haki and Devil Fruits"
    ]
  },
  {
    slug: 'monkey-d-garp',
    name: 'Monkey D. Garp',
    aliases: ['Hero of the Marines', 'Garp the Fist'],
    crew: 'Marines',
    role: 'Vice Admiral (former)',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/5/509073.jpg',
    bio: "Luffy's grandfather. Fought Gol D. Roger multiple times and was called the Hero of the Marines for cornering the Pirate King. Wanted Luffy and Ace to become Marines. One of the strongest characters in the series despite having no Devil Fruit — his fists alone put him on the same level as Roger.",
    details: [
      "Offered the rank of Admiral multiple times and always refused",
      "Adopted Ace at Roger's request before Roger's execution",
      "Can use Conqueror's Haki and imbue his fists with it",
      "Galaxy Impact: a Haki-infused punch that can shatter the ground from the sky",
      "Captured by Blackbeard's crew on Hachinosu (Pirate Island) while rescuing Koby"
    ]
  },
  {
    slug: 'silvers-rayleigh',
    name: 'Silvers Rayleigh',
    aliases: ['Dark King'],
    crew: 'Roger Pirates (former)',
    role: 'First Mate',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/16/141861.jpg',
    bio: "The right hand of the Pirate King. First mate of Gol D. Roger and one of the strongest people alive, even in his 70s. He trained Luffy in all three types of Haki during the two-year timeskip on Rusukaina Island. Lives in retirement on the Sabaody Archipelago.",
    details: [
      "The Marines know where he lives and leave him alone because fighting him is not worth the cost",
      "Swam through the Calm Belt (infested with Sea Kings) to reach Amazon Lily",
      "Stopped Kizaru, an Admiral, with his bare hands at Sabaody",
      "Works as a ship coating mechanic on Sabaody — coats ships in resin for the underwater journey to Fish-Man Island"
    ]
  },
  {
    slug: 'charlotte-katakuri',
    name: 'Charlotte Katakuri',
    aliases: ['Dogtooth'],
    crew: 'Big Mom Pirates',
    role: 'Sweet Commander',
    devilFruit: 'Mochi Mochi no Mi (Mochi-Mochi Fruit)',
    devilFruitType: 'Special Paramecia',
    bounty: '1,057,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/8/342776.jpg',
    bio: "The strongest of Big Mom's 85 children. His Mochi Mochi no Mi lets him reshape his body like mochi and mimic other fighting styles. He has Advanced Observation Haki that lets him see slightly into the future. Luffy's fight with him in the Mirror World ran 11 hours — Katakuri had a perfect combat record his entire life until Luffy broke it.",
    details: [
      "Bounty of 1,057,000,000 berries",
      "Can see a few seconds into the future using Observation Haki",
      "Hides a pelican eel-like mouth behind his scarf — he was bullied for it as a child",
      "Intentionally stabbed himself during the fight with Luffy to make it fair after his sister interfered",
      "One of the most respected antagonists in the series because of his honor"
    ]
  },
  {
    slug: 'kuzan-aokiji',
    name: 'Kuzan',
    aliases: ['Aokiji', 'Blue Pheasant'],
    crew: 'Blackbeard Pirates (allied) / Marines (former)',
    role: 'Former Admiral',
    devilFruit: 'Hie Hie no Mi (Ice-Ice Fruit)',
    devilFruitType: 'Logia',
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/9/96167.jpg',
    bio: "Kuzan, better known by his former title Aokiji, is a former Marine Admiral. He ate the Ice-Ice Fruit, turning him into a Freezing Man. He was a former friend of Vice Admiral Jaguar D. Saul and shares a history with Nico Robin. Currently he is allied with the Blackbeard Pirates for unknown reasons.",
    details: [
      "Lost the fight for Fleet Admiral position to Akainu on Punk Hazard — their 10-day battle permanently changed the island's climate",
      "Lost a leg in the fight and replaced it with an ice prosthetic",
      "Befriended Jaguar D. Saul, the giant Marine who saved Robin during the Ohara Buster Call",
      "Let Robin escape as a child because of his friendship with Saul",
      "His true motives after leaving the Marines remain unknown"
    ]
  },
  {
    slug: 'nefertari-vivi',
    name: 'Nefertari Vivi',
    aliases: ['Miss Wednesday'],
    crew: 'Alabasta Kingdom / Honorary Straw Hat',
    role: 'Princess of Alabasta',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/9/298188.jpg',
    bio: "Princess of Alabasta who went undercover in Baroque Works as Miss Wednesday to find out who was destabilizing her kingdom. She teamed up with the Straw Hat crew to defeat Crocodile and save Alabasta. Though she stayed behind when the Straw Hats left, she is considered an honorary crew member.",
    details: [
      "Infiltrated Baroque Works with her guardian Igaram to discover Mr. 0's identity",
      "Traveled with the Straw Hats from Whiskey Peak through Alabasta",
      "Her farewell scene — showing the X mark on her arm — is one of the most iconic moments in the series",
      "Her family, the Nefertari clan, is one of the 20 founding families who created the World Government but refused to move to Mariejois"
    ]
  },
  {
    slug: 'kinemon',
    name: "Kin'emon",
    aliases: ['Foxfire Kin\'emon'],
    crew: 'Nine Red Scabbards / Kozuki Clan',
    role: 'Leader of the Nine Red Scabbards',
    devilFruit: 'Fuku Fuku no Mi (Garb-Garb Fruit)',
    devilFruitType: 'Paramecia',
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/8/230765.jpg',
    bio: "A samurai from the Land of Wano. He is an ally to the Straw Hat-Heart Pirate Alliance and the leader and captain of the Nine Red Scabbards — the retainers of Kozuki Oden. He traveled 20 years into the future using Toki's Devil Fruit to find allies who could help overthrow Kaido.",
    details: [
      "His Foxfire Style lets him cut through fire",
      "His Devil Fruit creates disguises out of leaves and stones placed on the head",
      "Posed as Momonosuke's father to protect the boy's identity as heir to the Kozuki clan",
      "Led the raid on Onigashima alongside the Straw Hats and the samurai of Wano"
    ]
  },
  {
    slug: 'eustass-kid',
    name: 'Eustass Kid',
    aliases: ['Captain Kid'],
    crew: 'Kid Pirates',
    role: 'Captain',
    devilFruit: 'Jiki Jiki no Mi (Magnet-Magnet Fruit)',
    devilFruitType: 'Paramecia',
    bounty: '3,000,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/12/146187.jpg',
    bio: "One of the Eleven Supernovas and among the most dangerous of the Worst Generation. Captain of the Kid Pirates and Luffy's main rival among the supernovas. His Magnet-Magnet Fruit lets him attract and repel metal, which he uses to create giant metal arms, weapons, and constructs. Lost his left arm to Shanks at some point during the timeskip.",
    details: [
      "Bounty of 3,000,000,000 berries",
      "The only other Worst Generation crew besides the Straw Hats to have two supernovas (Kid and Killer)",
      "Awakened his Devil Fruit and used it to assign magnetic polarity to people, causing metal to slam into them",
      "Defeated Big Mom alongside Trafalgar Law in Wano",
      "Later defeated by Shanks with a single attack in Elbaf"
    ]
  },
  {
    slug: 'carrot',
    name: 'Carrot',
    aliases: [],
    crew: 'Mokomo Dukedom',
    role: 'Rabbit Mink, Ruler of Zou',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/13/547105.webp',
    bio: "A rabbit Mink from the Mokomo Dukedom on Zou. She is part of the Battlebeast Tribe. She stowed away on the Thousand Sunny and joined the Straw Hats for the Whole Cake Island and Wano arcs. Her Sulong transformation under the full moon turns her into a powerful electrified white form.",
    details: [
      "Sulong form dramatically increases her speed and electrical attacks (Electro)",
      "Fought alongside the Straw Hats at Whole Cake Island and during the Wano raid",
      "Was asked by Pedro (before his death) to help bring about the Dawn of the world",
      "Chosen to lead the Mokomo Dukedom after the Wano arc"
    ]
  },
  {
    slug: 'kozuki-momonosuke',
    name: 'Kozuki Momonosuke',
    aliases: [],
    crew: 'Kozuki Clan',
    role: 'Shogun of Wano',
    devilFruit: 'Artificial Uo Uo no Mi (Fish-Fish Fruit, artificial)',
    devilFruitType: 'Artificial Zoan',
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/15/235843.jpg',
    bio: "The son of Kozuki Oden and heir to the Kozuki clan. He ate an artificial Devil Fruit created by Vegapunk that transforms him into a dragon. He was sent 20 years into the future by his mother Toki's time powers to one day reclaim Wano from Kaido. After the raid on Onigashima, he became the Shogun of Wano.",
    details: [
      "Son of Kozuki Oden and Kozuki Toki",
      "His artificial fruit is a copy of Kaido's mythical Fish-Fish Fruit, Model: Azure Dragon",
      "Aged into an adult by Shinobu's Devil Fruit during the Wano raid to carry Luffy",
      "Can command the elephant Zunesha, a thousand-year-old giant that carries Zou on its back",
      "Kin'emon posed as his father throughout the Punk Hazard and Dressrosa arcs to protect him"
    ]
  },
  {
    slug: 'kaku',
    name: 'Kaku',
    aliases: ['Mountain Wind'],
    crew: 'CP0 (formerly CP9)',
    role: 'Agent',
    devilFruit: 'Ushi Ushi no Mi, Model: Giraffe (Ox-Ox Fruit)',
    devilFruitType: 'Zoan',
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/12/51463.jpg',
    bio: "A member of CP9 who possesses the power of the Giraffe Devil Fruit. First appeared as one of the five foremen of Galley-La Company's Dock One, specializing in ship diagnostics. His cover was blown when CP9 revealed themselves and kidnapped Nico Robin. After CP9 was defeated, he returned as a member of CP0.",
    details: [
      "Went undercover at Galley-La Company alongside Rob Lucci for five years",
      "Fought Roronoa Zoro at Enies Lobby — one of the most entertaining fights in the arc",
      "Uses Rankyaku (Tempest Kick) combined with his giraffe neck for extended range",
      "Friendly and somewhat goofy personality despite being a government assassin"
    ]
  },
  {
    slug: 'x-drake',
    name: 'X. Drake',
    aliases: ['Red Flag'],
    crew: 'SWORD (secret Marine unit) / Drake Pirates',
    role: 'Former Rear Admiral / Captain',
    devilFruit: 'Ryu Ryu no Mi, Model: Allosaurus (Dragon-Dragon Fruit)',
    devilFruitType: 'Ancient Zoan',
    bounty: '222,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/10/146041.jpg',
    bio: "A former rear admiral of the Navy who left the military to become the captain of the Drake Pirates. After the timeskip, he joined Kaido's crew as part of the Tobiroppo (Flying Six). He ate an Ancient Zoan Devil Fruit that lets him transform into an Allosaurus. In reality, he is a double agent working for SWORD, the Marines' secret anti-pirate unit.",
    details: [
      "Bounty of 222,000,000 berries",
      "One of the Eleven Supernovas of the Worst Generation",
      "Son of Barrels, a former Marine turned pirate — Drake's childhood was violent",
      "Was secretly feeding information to the Marines while inside Kaido's crew",
      "Revealed himself as a SWORD agent during the Wano raid"
    ]
  },
  {
    slug: 'bartholomew-kuma',
    name: 'Bartholomew Kuma',
    aliases: ['Tyrant', 'The Pacifist'],
    crew: 'Revolutionary Army (former) / Warlord (former)',
    role: 'Former Warlord, Pacifista prototype',
    devilFruit: 'Nikyu Nikyu no Mi (Paw-Paw Fruit)',
    devilFruitType: 'Paramecia',
    bounty: '296,000,000 (frozen)',
    image: 'https://cdn.myanimelist.net/images/characters/2/54820.webp',
    bio: "Kuma used to be a powerful pirate before he allowed the World Government to experiment on him and turn him into a cyborg. He was a Warlord and secretly a member of the Revolutionary Army. He ate the Paw-Paw Fruit, which lets him repel anything — air, pain, even people — at the speed of light using the pads on his palms.",
    details: [
      "Former bounty of 296,000,000 berries",
      "Sent each Straw Hat to a different island at Sabaody to save them — this split the crew for two years",
      "Guarded the Thousand Sunny for two years while the crew was separated",
      "Was fully converted into a mindless Pacifista weapon by Vegapunk, losing his free will",
      "His past as a slave of the Celestial Dragons was revealed during the Egghead arc",
      "Father of Jewelry Bonney"
    ]
  },
  {
    slug: 'sabo',
    name: 'Sabo',
    aliases: ['Flame Emperor', 'No. 2 of the Revolutionary Army'],
    crew: 'Revolutionary Army',
    role: 'Chief of Staff',
    devilFruit: 'Mera Mera no Mi (Flame-Flame Fruit)',
    devilFruitType: 'Logia',
    bounty: '602,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/15/131855.jpg',
    bio: "Luffy and Ace's childhood sworn brother. Everyone believed he died as a child when a Celestial Dragon's ship fired on his boat. He survived but lost his memories, and was taken in by Dragon and the Revolutionary Army. He resurfaced at Dressrosa and won Ace's Mera Mera no Mi at the Corrida Colosseum. Second in command under Monkey D. Dragon.",
    details: [
      "Bounty of 602,000,000 berries",
      "Born a noble in the Goa Kingdom but ran away because he hated the nobles' cruelty",
      "Lost his memory after being shot by a Celestial Dragon's ship as a child",
      "His memories returned when he read the news of Ace's death at Marineford",
      "Inherited Ace's Flame-Flame Fruit and his will",
      "Declared 'Flame Emperor' by the media after the Reverie incident"
    ]
  },
  {
    slug: 'sakazuki-akainu',
    name: 'Sakazuki',
    aliases: ['Akainu', 'Red Dog'],
    crew: 'Marines',
    role: 'Fleet Admiral',
    devilFruit: 'Magu Magu no Mi (Magma-Magma Fruit)',
    devilFruitType: 'Logia',
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/16/306908.jpg',
    bio: "The current Fleet Admiral of the Marines. His Magma-Magma Fruit produces magma hot enough to burn through fire itself — which is how he killed Portgas D. Ace at Marineford, punching through Ace's fire Logia body. He believes in 'Absolute Justice' and will sacrifice anything, including innocent lives, to eliminate pirates.",
    details: [
      "Killed Ace at Marineford while Ace was protecting Luffy",
      "Defeated Aokiji in a 10-day fight on Punk Hazard to become Fleet Admiral",
      "Their fight permanently changed Punk Hazard's climate — half frozen, half volcanic",
      "Ordered the destruction of an entire refugee ship at Ohara to prevent scholars from escaping",
      "His scar across his chest was given by Whitebeard at Marineford"
    ]
  },
  {
    slug: 'borsalino-kizaru',
    name: 'Borsalino',
    aliases: ['Kizaru', 'Yellow Monkey'],
    crew: 'Marines',
    role: 'Admiral',
    devilFruit: 'Pika Pika no Mi (Glint-Glint Fruit)',
    devilFruitType: 'Logia',
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/12/96168.jpg',
    bio: "A Marine Admiral who ate the Glint-Glint Fruit, letting him move and attack at the speed of light. He can fire laser beams from his fingertips, travel as a beam of light, and form a sword out of light. Despite having arguably the most powerful speed in the series, he acts lazy and unbothered in every situation.",
    details: [
      "Single-handedly destroyed the Straw Hats at Sabaody Archipelago before the timeskip",
      "Fought Rayleigh to a standstill at Sabaody",
      "His lasers were replicated by Vegapunk for the Pacifista program",
      "Played a major role in the Egghead arc — tasked with eliminating Vegapunk"
    ]
  },
  {
    slug: 'edward-newgate',
    name: 'Edward Newgate',
    aliases: ['Whitebeard', 'The Strongest Man in the World'],
    crew: 'Whitebeard Pirates',
    role: 'Captain / Former Emperor',
    devilFruit: 'Gura Gura no Mi (Tremor-Tremor Fruit)',
    devilFruitType: 'Paramecia',
    bounty: '5,046,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/3/100236.jpg',
    bio: "Known as the Strongest Man in the World. Captain of the Whitebeard Pirates and one of the Four Emperors. His Tremor-Tremor Fruit could create earthquakes strong enough to destroy the world. He considered his crew his family — his sons — and went to war with the entire World Government to save Ace. He died standing at Marineford, covered in wounds, without ever showing his back to the enemy.",
    details: [
      "Bounty of 5,046,000,000 berries — the second highest known bounty ever",
      "Rival of Gol D. Roger in the old era",
      "His final words at Marineford confirmed that the One Piece is real",
      "Died with 267 sword wounds, 152 gunshot wounds, and 46 cannon wounds — and zero wounds on his back",
      "After his death, Blackbeard stole his Tremor-Tremor Fruit"
    ]
  },
  {
    slug: 'enel',
    name: 'Enel',
    aliases: ['God Enel', 'Eneru'],
    crew: 'God\'s Army (Skypiea)',
    role: 'Former God of Skypiea',
    devilFruit: 'Goro Goro no Mi (Rumble-Rumble Fruit)',
    devilFruitType: 'Logia',
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/16/55111.jpg',
    bio: "The self-proclaimed God of Skypiea who ruled through fear and lightning. His Rumble-Rumble Fruit lets him become, create, and control lightning — one of the most powerful Logia fruits in existence. Oda confirmed that if Enel were a pirate on the Blue Sea, his bounty would be around 500,000,000 berries. He was only defeated because Luffy's rubber body is immune to electricity.",
    details: [
      "Destroyed his own homeland, Birka, before taking over Skypiea",
      "Used his lightning powers combined with Observation Haki (Mantra) to listen to the entire island",
      "Wanted to reach the moon — and actually did, after Luffy defeated him",
      "His cover story on the moon revealed ancient technology and an army of robots",
      "Luffy is his natural enemy — rubber does not conduct electricity"
    ]
  },
  {
    slug: 'magellan',
    name: 'Magellan',
    aliases: [],
    crew: 'Impel Down',
    role: 'Former Chief Warden',
    devilFruit: 'Doku Doku no Mi (Venom-Venom Fruit)',
    devilFruitType: 'Paramecia',
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/9/79445.jpg',
    bio: "The former Chief Warden of Impel Down, the world's most secure prison. His Venom-Venom Fruit lets him produce and control all types of poison. He single-handedly defeated Luffy, Blackbeard, and nearly everyone who tried to escape Impel Down. Despite being on the government's side, he is one of the most powerful characters shown in the series.",
    details: [
      "Defeated Luffy with a single Hydra attack — Luffy nearly died and was saved by Ivankov",
      "Also defeated Blackbeard's entire crew on his own",
      "Venom Demon: his strongest poison creates a giant demon that melts everything it touches",
      "Spends most of his day on the toilet because his own poison gives him constant diarrhea",
      "Demoted to Vice Warden after the mass breakout during the Impel Down arc"
    ]
  },
  {
    slug: 'gol-d-roger',
    name: 'Gol D. Roger',
    aliases: ['Pirate King', 'Gold Roger'],
    crew: 'Roger Pirates',
    role: 'Captain / The Pirate King',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: '5,564,800,000',
    image: 'https://cdn.myanimelist.net/images/characters/3/51747.jpg',
    bio: "The King of the Pirates — the only person to ever conquer the Grand Line and reach Laugh Tale. His execution 24 years ago started the Great Pirate Era when he announced that his treasure, the One Piece, was real and waiting for whoever could find it. His real name was Gol D. Roger, but the World Government changed it to 'Gold Roger' to hide the D. in his name.",
    details: [
      "Bounty of 5,564,800,000 berries — the highest known bounty in history",
      "Father of Portgas D. Ace",
      "His first mate was Silvers Rayleigh",
      "Turned himself in to the Marines — his execution was public in Loguetown",
      "Could hear the Voice of All Things, allowing him to understand Poneglyphs",
      "Shanks and Buggy were cabin boys on his ship"
    ]
  },
  {
    slug: 'monkey-d-dragon',
    name: 'Monkey D. Dragon',
    aliases: ['The World\'s Worst Criminal'],
    crew: 'Revolutionary Army',
    role: 'Supreme Commander',
    devilFruit: null,
    devilFruitType: null,
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/6/193567.jpg',
    bio: "Luffy's father and the leader of the Revolutionary Army, the organization fighting to overthrow the World Government. Called 'The World's Worst Criminal' by the government. He saved Luffy from Smoker at Loguetown. Despite being one of the most important figures in the story, very little about his powers or past has been revealed.",
    details: [
      "Son of Monkey D. Garp",
      "Father of Monkey D. Luffy — Luffy didn't know until Garp told him at Water 7",
      "Sabo is his second-in-command",
      "The Revolutionary Army declared war on the Celestial Dragons at the Reverie",
      "His Devil Fruit (if he has one) has not been confirmed"
    ]
  },
  {
    slug: 'kozuki-oden',
    name: 'Kozuki Oden',
    aliases: [],
    crew: 'Roger Pirates / Whitebeard Pirates (former)',
    role: 'Daimyo of Kuri, former Shogun heir',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/4/433930.jpg',
    bio: "The legendary samurai of Wano. Daimyo of Kuri who sailed with both Whitebeard and Roger. One of the few people who could read Poneglyphs. He wielded the swords Ame no Habakiri and Enma. He was executed by Kaido and the shogun Orochi after being boiled alive for one hour while holding his retainers above his head.",
    details: [
      "Father of Momonosuke and Hiyori",
      "The only person to ever wound Kaido, leaving a permanent scar",
      "Sailed to Laugh Tale with Roger and learned the true history of the world",
      "His sword Enma was later inherited by Zoro",
      "His death scene — the Legendary Hour — is one of the most famous in the series"
    ]
  },
  {
    slug: 'perona',
    name: 'Perona',
    aliases: ['Ghost Princess'],
    crew: 'Thriller Bark (former)',
    role: 'Commander under Gecko Moria',
    devilFruit: 'Horo Horo no Mi (Hollow-Hollow Fruit)',
    devilFruitType: 'Paramecia',
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/15/136777.jpg',
    bio: "The Ghost Princess of Thriller Bark. Her Hollow-Hollow Fruit lets her create ghosts that pass through people and make them completely negative and depressed. She also creates explosive mini-ghosts. After Thriller Bark fell, she ended up at Mihawk's castle where she lived alongside Zoro during the timeskip.",
    details: [
      "Only Usopp could resist her ghosts — because he was already so negative",
      "Lived at Mihawk's castle during the two-year timeskip",
      "Took care of Mihawk's home like a reluctant houseguest",
      "Has a gothic lolita aesthetic — obsessed with cute and creepy things"
    ]
  },
  {
    slug: 'jewelry-bonney',
    name: 'Jewelry Bonney',
    aliases: ['Big Eater'],
    crew: 'Bonney Pirates',
    role: 'Captain',
    devilFruit: 'Toshi Toshi no Mi (Age-Age Fruit)',
    devilFruitType: 'Paramecia',
    bounty: '320,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/14/146045.jpg',
    bio: "One of the Eleven Supernovas of the Worst Generation. Her Age-Age Fruit lets her change the age of anyone she touches — including herself. She can turn herself into a child or an old woman, and age opponents into babies or elders. She is the daughter of Bartholomew Kuma.",
    details: [
      "One of the Worst Generation supernovas",
      "Daughter of Bartholomew Kuma",
      "Key character in the Egghead arc — traveled with the Straw Hats to find Vegapunk",
      "Can age or de-age anyone she touches",
      "Known for eating massive amounts of food"
    ]
  },
  {
    slug: 'basil-hawkins',
    name: 'Basil Hawkins',
    aliases: ['The Magician'],
    crew: 'Hawkins Pirates / Beasts Pirates (former)',
    role: 'Captain',
    devilFruit: 'Wara Wara no Mi (Straw-Straw Fruit)',
    devilFruitType: 'Paramecia',
    bounty: '320,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/8/391979.jpg',
    bio: "One of the Eleven Supernovas. His Straw-Straw Fruit lets him redirect any damage he takes to other people using straw voodoo dolls. He uses tarot cards to predict the future and make tactical decisions based on probability. He joined Kaido's crew after the timeskip because his cards told him he had zero chance of winning.",
    details: [
      "One of the Worst Generation supernovas",
      "Can create a giant straw demon by awakening his Devil Fruit",
      "Redirects damage to subordinates using voodoo dolls inside his body",
      "Fought Killer during the Wano raid — lost his left arm",
      "Makes all decisions based on tarot card probability readings"
    ]
  },
  {
    slug: 'capone-bege',
    name: 'Capone "Gang" Bege',
    aliases: ['Gang Bege'],
    crew: 'Fire Tank Pirates',
    role: 'Captain',
    devilFruit: 'Shiro Shiro no Mi (Castle-Castle Fruit)',
    devilFruitType: 'Paramecia',
    bounty: '350,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/9/146047.jpg',
    bio: "One of the Eleven Supernovas. His Castle-Castle Fruit turns his body into a living fortress — soldiers, cannons, and horses can exist inside him at miniature scale and deploy at full size when they exit. A mafia-style pirate captain who married Charlotte Chiffon, one of Big Mom's daughters, as part of a plan to assassinate Big Mom.",
    details: [
      "One of the Worst Generation supernovas",
      "His body is a literal fortress with cannons, soldiers, and supplies inside",
      "Big Father: transforms into a giant castle-like golem",
      "Married Charlotte Chiffon — they have a son named Pez",
      "Allied with Luffy during the Whole Cake Island arc to try to kill Big Mom"
    ]
  },
  {
    slug: 'emporio-ivankov',
    name: 'Emporio Ivankov',
    aliases: ['Iva', 'Miracle Person', 'Queen of Kamabakka Kingdom'],
    crew: 'Revolutionary Army',
    role: 'Commander, Grand Line Army',
    devilFruit: 'Horu Horu no Mi (Hormone-Hormone Fruit)',
    devilFruitType: 'Paramecia',
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/6/81182.jpg',
    bio: "A commander in the Revolutionary Army and the queen of the Kamabakka Kingdom. His Hormone-Hormone Fruit lets him inject hormones that can change a person's gender, physical appearance, body temperature, pigmentation, or emotional state. He was imprisoned in Impel Down Level 5.5 (the secret level) and helped Luffy break out.",
    details: [
      "Saved Luffy's life twice — once by injecting healing hormones that cost Luffy 10 years of lifespan",
      "Created a secret paradise in Impel Down Level 5.5 called 'Newkama Land'",
      "Trained Sanji during the timeskip on Kamabakka Kingdom (against Sanji's will)",
      "Death Wink: a wink so powerful it creates a shockwave"
    ]
  },
  {
    slug: 'bentham-mr-2',
    name: 'Bentham',
    aliases: ['Mr. 2 Bon Clay', 'Bon-chan'],
    crew: 'Baroque Works (former) / Newkama Land',
    role: 'Agent / New Queen of Level 5.5',
    devilFruit: 'Mane Mane no Mi (Clone-Clone Fruit)',
    devilFruitType: 'Paramecia',
    bounty: '32,000,000 (frozen)',
    image: 'https://cdn.myanimelist.net/images/characters/6/146037.jpg',
    bio: "Originally an officer of Baroque Works who became one of the Straw Hats' most loyal friends. His Clone-Clone Fruit lets him copy anyone's face and body by touching them. He sacrificed himself twice for Luffy — once at Alabasta to help the crew escape, and again at Impel Down where he impersonated Magellan to open the Gates of Justice.",
    details: [
      "Started as an enemy in Alabasta, became one of the most beloved characters in the series",
      "His friendship with Luffy is entirely built on mutual respect and honor",
      "Sacrificed himself at the Gates of Justice so Luffy could escape Impel Down",
      "Survived and became the new queen of Newkama Land (Level 5.5 in Impel Down)",
      "Okama Kenpo: a martial art combining ballet and kicks"
    ]
  },
  {
    slug: 'bartolomeo',
    name: 'Bartolomeo',
    aliases: ['Bartolomeo the Cannibal'],
    crew: 'Barto Club',
    role: 'Captain',
    devilFruit: 'Bari Bari no Mi (Barrier-Barrier Fruit)',
    devilFruitType: 'Paramecia',
    bounty: '200,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/13/249217.jpg',
    bio: "Captain of the Barto Club and Luffy's biggest fanboy. His Barrier-Barrier Fruit creates invisible barriers that nothing can break through. He was inspired to become a pirate after watching Luffy at Loguetown. He joined the Straw Hat Grand Fleet at Dressrosa.",
    details: [
      "Became a pirate after witnessing Luffy's near-execution at Loguetown",
      "Named his ship the Going Luffy-senpai",
      "His barriers are completely indestructible — even Elizabello's King Punch bounced off",
      "Part of the Straw Hat Grand Fleet (1st Ship)",
      "Burned a Red Hair Pirates flag in their territory, causing an incident with Shanks"
    ]
  },
  {
    slug: 'cavendish',
    name: 'Cavendish',
    aliases: ['White Horse', 'Hakuba'],
    crew: 'Beautiful Pirates',
    role: 'Captain',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: '330,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/15/280596.jpg',
    bio: "Captain of the Beautiful Pirates and a former prince. A narcissist who is furious that the Worst Generation stole his spotlight. Has a split personality called Hakuba that emerges when he sleeps — Hakuba is an uncontrollably fast swordsman who attacks everyone around him. Joined the Straw Hat Grand Fleet at Dressrosa.",
    details: [
      "Part of the Straw Hat Grand Fleet",
      "His sword Durandal is one of the finest blades in the world",
      "Hakuba moves so fast that people only see the aftermath of his attacks",
      "Competed in the Corrida Colosseum at Dressrosa"
    ]
  },
  {
    slug: 'charlotte-pudding',
    name: 'Charlotte Pudding',
    aliases: ['Three-Eye Tribe'],
    crew: 'Big Mom Pirates',
    role: "Big Mom's 35th Daughter",
    devilFruit: 'Memo Memo no Mi (Memo-Memo Fruit)',
    devilFruitType: 'Paramecia',
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/9/328672.jpg',
    bio: "Big Mom's 35th daughter who was arranged to marry Sanji during the Whole Cake Island arc. Has a third eye hidden under her bangs — a trait from the Three-Eye Tribe that may let her read Poneglyphs. Her Memo-Memo Fruit lets her edit and remove people's memories like film strips. Initially pretended to love Sanji as part of Big Mom's trap, but fell in love with him for real after he called her third eye beautiful.",
    details: [
      "Was arranged to marry Sanji as part of Big Mom's plot to assassinate the Vinsmoke family",
      "Fell in love with Sanji after he was the first person to call her third eye beautiful",
      "Can extract, edit, and replace memories",
      "Helped Sanji and the Straw Hats escape Whole Cake Island",
      "Her third eye may awaken the ability to read Poneglyphs"
    ]
  },
  {
    slug: 'charlotte-perospero',
    name: 'Charlotte Perospero',
    aliases: [],
    crew: 'Big Mom Pirates',
    role: "Big Mom's 1st Son, Minister of Candy",
    devilFruit: 'Pero Pero no Mi (Lick-Lick Fruit)',
    devilFruitType: 'Paramecia',
    bounty: '700,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/13/356310.jpg',
    bio: "The eldest son of Big Mom and the Minister of Candy on Whole Cake Island. His Candy Fruit lets him create and manipulate candy — he uses it to build structures, weapons, and even a candy arm to replace the one he lost. He lied to Big Mom about the Straw Hats destroying the wedding cake, which set off her rampage.",
    details: [
      "Lost his right arm in Pedro's suicide explosion — replaced it with a candy prosthetic",
      "His candy constructions are strong enough to build bridges and escalators",
      "Fought against Marco and Carrot's Sulong form during the Wano raid"
    ]
  },
  {
    slug: 'shirahoshi',
    name: 'Shirahoshi',
    aliases: ['Poseidon'],
    crew: 'Ryugu Kingdom',
    role: 'Princess of the Fish-Man Island',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/14/159079.jpg',
    bio: "The giant mermaid princess of Fish-Man Island. She is the current incarnation of the Ancient Weapon Poseidon — she can communicate with and command Sea Kings, the massive creatures that live in the Calm Belt. She spent 10 years locked in her tower because of Vander Decken IX, who could throw objects that would always fly toward her.",
    details: [
      "One of the three Ancient Weapons (Poseidon)",
      "Can summon and command Sea Kings",
      "Befriended Luffy when he snuck into her tower",
      "Enormous in size — even among merfolk she is a giant",
      "Her power is why the World Government considers her a threat"
    ]
  },
  {
    slug: 'caesar-clown',
    name: 'Caesar Clown',
    aliases: ['Master', 'Gangster Gastino'],
    crew: 'Independent / Former World Government scientist',
    role: 'Scientist',
    devilFruit: 'Gasu Gasu no Mi (Gas-Gas Fruit)',
    devilFruitType: 'Logia',
    bounty: '300,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/7/235823.jpg',
    bio: "A mad scientist and former colleague of Vegapunk. His Gas-Gas Fruit lets him create, control, and become any type of gas — including poison gas and oxygen removal. He was conducting illegal experiments on children at Punk Hazard, using them to develop weapons of mass destruction. Defeated by Luffy and later dragged along as a hostage through Dressrosa and Whole Cake Island.",
    details: [
      "Created the weapon Shinokuni, a poison gas that petrifies anything it touches",
      "Experimented on kidnapped children at Punk Hazard, enlarging them with drugs",
      "Worked for both Doflamingo and Big Mom at various points",
      "Can remove oxygen from an area, suffocating everyone inside",
      "Disguised himself as 'Gangster Gastino' at Whole Cake Island (nobody was fooled)"
    ]
  },
  {
    slug: 'tashigi',
    name: 'Tashigi',
    aliases: [],
    crew: 'Marines',
    role: 'Captain (under Smoker)',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/2/266983.jpg',
    bio: "A Marine Captain who serves under Smoker. She is a skilled swordswoman who collects named blades and wants to reclaim all great swords from unworthy pirates. She looks almost identical to Zoro's childhood friend Kuina, which unnerves him every time they meet.",
    details: [
      "Looks nearly identical to Kuina, Zoro's deceased childhood rival",
      "Her sword Shigure is a Meito (named blade)",
      "Her body was swapped with Smoker's by Law on Punk Hazard",
      "Follows Smoker's brand of justice — cares more about doing right than following orders"
    ]
  },
  {
    slug: 'scratchmen-apoo',
    name: 'Scratchmen Apoo',
    aliases: ['Roar of the Sea'],
    crew: 'On Air Pirates',
    role: 'Captain',
    devilFruit: 'Unknown (music-based)',
    devilFruitType: 'Unknown',
    bounty: '350,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/14/91154.jpg',
    bio: "One of the Eleven Supernovas. His unnamed Devil Fruit turns his body into musical instruments — his teeth become piano keys, his arms become cymbals, his chest becomes a drum. Anyone who hears him play takes damage based on the type of sound. He betrayed Kid and Hawkins' alliance and was secretly working for Kaido.",
    details: [
      "One of the Worst Generation supernovas",
      "His attacks only work if the target can hear the music",
      "Betrayed Kid and Hawkins by selling them out to Kaido",
      "Worked as an informant for the Beasts Pirates",
      "Attacked both Luffy and Zoro during the raid on Onigashima"
    ]
  },
  {
    slug: 'urouge',
    name: 'Urouge',
    aliases: ['Mad Monk'],
    crew: 'Fallen Monk Pirates',
    role: 'Captain',
    devilFruit: 'Unknown (damage conversion)',
    devilFruitType: 'Unknown',
    bounty: '108,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/9/128325.jpg',
    bio: "One of the Eleven Supernovas from a sky island. His unnamed Devil Fruit lets him convert damage he receives into physical strength — the more he gets hit, the stronger and larger he becomes. The least shown of the Worst Generation but confirmed to have defeated one of Big Mom's Sweet Commanders (Snack) before the timeskip.",
    details: [
      "One of the Worst Generation supernovas",
      "Originally from a sky island (Birka or another)",
      "Defeated Charlotte Snack, one of Big Mom's Sweet Commanders",
      "Grows in size and strength proportional to damage taken",
      "Uses a large pillar as his weapon"
    ]
  },
  {
    slug: 'hody-jones',
    name: 'Hody Jones',
    aliases: [],
    crew: 'New Fish-Man Pirates',
    role: 'Captain',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/4/159077.jpg',
    bio: "The main villain of the Fish-Man Island arc. A great white shark fish-man who took over the Fish-Man Island and tried to start a war between fish-men and humans. He used Energy Steroids to artificially boost his power. He represents inherited hatred — he hates humans not from personal experience but from stories told to him.",
    details: [
      "His hatred of humans is entirely inherited, not based on anything that happened to him personally",
      "Used Energy Steroids to gain temporary power boosts at the cost of his lifespan",
      "Tried to assassinate Queen Otohime as a child",
      "Defeated by Luffy — a fight that showed how far Luffy had come post-timeskip"
    ]
  },
  {
    slug: 'spandam',
    name: 'Spandam',
    aliases: [],
    crew: 'CP9 / CP0',
    role: 'Former Chief of CP9',
    devilFruit: 'None (sword Funkfreed has Zou Zou no Mi)',
    devilFruitType: null,
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/6/71512.jpg',
    bio: "The former chief of CP9 and the man who ordered the capture of Nico Robin and the blueprints for Pluton. One of the most despised villains in the series — weak, cowardly, and cruel. His father Spandine was the man who ordered the Buster Call on Ohara. Spandam carries a sword called Funkfreed that ate the Elephant-Elephant Fruit.",
    details: [
      "Ordered the Buster Call on Enies Lobby",
      "His father Spandine ordered the Buster Call on Ohara 20 years prior",
      "Physically the weakest character in CP9",
      "Robin broke his spine on the Bridge of Hesitation",
      "Now serves under Rob Lucci in CP0 — a complete reversal of their old ranks"
    ]
  },
  {
    slug: 'iceburg',
    name: 'Iceburg',
    aliases: [],
    crew: 'Galley-La Company',
    role: 'President / Mayor of Water 7',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/10/51467.jpg',
    bio: "The mayor of Water 7 and president of the Galley-La shipbuilding company. A former apprentice of Tom alongside Franky. He inherited the blueprints for the ancient weapon Pluton from Tom, and kept them secret for years. CP9 infiltrated his company for five years trying to steal those blueprints.",
    details: [
      "Apprenticed under Tom the fishman alongside Franky (Cutty Flam)",
      "Held the Pluton blueprints — eventually gave them to Franky, who destroyed them",
      "Was shot by CP9 agents (including Robin, under duress) during the Water 7 arc",
      "Keeps a pet mouse in his pocket"
    ]
  },
  {
    slug: 'daz-bones',
    name: 'Daz Bones',
    aliases: ['Mr. 1'],
    crew: 'Baroque Works (former) / Cross Guild',
    role: 'Agent',
    devilFruit: 'Supa Supa no Mi (Dice-Dice Fruit)',
    devilFruitType: 'Paramecia',
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/4/77645.jpg',
    bio: "The strongest officer of Baroque Works under the name Mr. 1. His Dice-Dice Fruit turns any part of his body into steel blades. His fight with Zoro in Alabasta forced Zoro to learn how to cut steel — a turning point in Zoro's growth as a swordsman. He later followed Crocodile to the New World and is now part of Cross Guild.",
    details: [
      "Was a bounty hunter from the West Blue before joining Baroque Works",
      "His body can become blades at will — arms, legs, even his head",
      "Zoro's fight against him is where Zoro first learned to cut steel",
      "Escaped Impel Down alongside Crocodile during the breakout",
      "Currently part of Cross Guild under Crocodile"
    ]
  },
  {
    slug: 'fujitora',
    name: 'Isshou',
    aliases: ['Fujitora', 'Purple Tiger'],
    crew: 'Marines',
    role: 'Admiral',
    devilFruit: 'Zushi Zushi no Mi (Press-Press Fruit)',
    devilFruitType: 'Paramecia',
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/14/235827.jpg',
    bio: "A Marine Admiral who was drafted through the World Military Draft after the timeskip. His Press-Press Fruit lets him control gravity — he can make objects heavier, create craters, levitate debris, and pull meteorites from space. He blinded himself years ago because he could no longer stand seeing the world's cruelty. Despite being a Marine, he has a strong moral compass and openly opposed the Warlord system.",
    details: [
      "Blinded himself deliberately before becoming an Admiral",
      "Can pull meteorites from space and drop them on battlefields",
      "Publicly apologized to the people of Dressrosa for the Marines' failure to stop Doflamingo",
      "Fought against Luffy at Dressrosa but let him escape because he respected what Luffy did",
      "Successfully pushed for the abolition of the Warlord system at the Reverie"
    ]
  },
  {
    slug: 'coby',
    name: 'Coby',
    aliases: ['Hero of the Rocky Port Incident'],
    crew: 'Marines / SWORD',
    role: 'Captain',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/11/49289.jpg',
    bio: "The first person Luffy met on his journey. Started as a terrified cabin boy forced to work for the pirate Alvida. Luffy inspired him to chase his dream of becoming a Marine. He trained under Garp and grew from the weakest character in the series into a Marine Captain with Observation Haki. He is a member of SWORD, the Marines' secret unit.",
    details: [
      "First character Luffy befriended — in the very first chapter/episode",
      "Awakened Observation Haki during the Marineford War",
      "Member of SWORD alongside X. Drake and Helmeppo",
      "Was kidnapped by Blackbeard on Hachinosu — Garp came to rescue him",
      "Stood up to Admiral Akainu at Marineford to stop the killing, even though it could have cost his life"
    ]
  },
  {
    slug: 'donquixote-rosinante',
    name: 'Donquixote Rosinante',
    aliases: ['Corazon'],
    crew: 'Marines (undercover) / Donquixote Pirates',
    role: 'Corazon (Heart Seat)',
    devilFruit: 'Nagi Nagi no Mi (Calm-Calm Fruit)',
    devilFruitType: 'Paramecia',
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/13/288038.jpg',
    bio: "Doflamingo's younger brother and a Marine Commander who went undercover in the Donquixote Pirates. His Calm-Calm Fruit creates soundproof barriers. He saved Law as a child — finding the Ope Ope no Mi for him and sacrificing his life so Law could escape. His death at Doflamingo's hands is one of the most heartbreaking moments in the series.",
    details: [
      "Born a Celestial Dragon, same as Doflamingo",
      "Pretended to be mute in the Donquixote Pirates to avoid suspicion",
      "Was a Marine Commander secretly reporting on Doflamingo",
      "Found the Ope Ope no Mi and fed it to Law to cure his Amber Lead poisoning",
      "Killed by his own brother Doflamingo after his cover was blown",
      "Law's jolly roger and crew name (Heart Pirates) are tributes to Corazon"
    ]
  },
  {
    slug: 'arlong',
    name: 'Arlong',
    aliases: ['Arlong the Saw'],
    crew: 'Arlong Pirates',
    role: 'Captain',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: '20,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/12/350919.jpg',
    bio: "A saw-shark fish-man who terrorized Nami's village for years. He forced Nami to work as his cartographer, promising to free her village if she paid 100 million berries. The first villain whose defeat made the audience cry — not because of the fight, but because of what it meant for Nami. His defeat at Arlong Park is where One Piece went from good to legendary.",
    details: [
      "Former member of the Sun Pirates under Fisher Tiger",
      "His bounty of 20,000,000 was the highest in East Blue",
      "Forced Nami into servitude for 8 years",
      "Luffy destroyed Arlong Park after Nami finally asked for help"
    ]
  },
  {
    slug: 'wapol',
    name: 'Wapol',
    aliases: ['Tin-Plate'],
    crew: 'Blik Pirates / Wapol Concern',
    role: 'Former King of Drum Island',
    devilFruit: 'Baku Baku no Mi (Munch-Munch Fruit)',
    devilFruitType: 'Paramecia',
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/5/49998.jpg',
    bio: "The former king of Drum Island who abandoned his people when Blackbeard attacked. His Munch-Munch Fruit lets him eat anything and merge it with his body. Luffy punched him off the top of Drum Castle. After his defeat, he built a toy company and somehow became king of a new country through the Reverie.",
    details: [
      "His cowardice left Drum Island defenseless against Blackbeard",
      "Can eat anything — metal, cannons, buildings, even people — and merge them with his body",
      "Became a successful toy manufacturer after his defeat"
    ]
  },
  {
    slug: 'bellamy',
    name: 'Bellamy',
    aliases: ['The Hyena'],
    crew: 'Bellamy Pirates (former)',
    role: 'Captain (former)',
    devilFruit: 'Bane Bane no Mi (Spring-Spring Fruit)',
    devilFruitType: 'Paramecia',
    bounty: '195,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/12/254857.jpg',
    bio: "A pirate who mocked Luffy in Jaya for believing in the Sky Island. Luffy beat him with a single punch. Years later at Dressrosa, Bellamy had changed — he admired Doflamingo and refused to betray him even after Doflamingo ordered his death. His final fight with Luffy at Dressrosa was one of mutual respect.",
    details: [
      "Knocked out by Luffy with one punch in Jaya",
      "His Spring-Spring Fruit turns his legs into springs for high-speed attacks",
      "Became a better man by Dressrosa but stayed loyal to Doflamingo out of pride",
      "Luffy punched him one last time at Dressrosa because Bellamy asked him to"
    ]
  },
  {
    slug: 'helmeppo',
    name: 'Helmeppo',
    aliases: [],
    crew: 'Marines / SWORD',
    role: 'Lieutenant Commander',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/14/48661.jpg',
    bio: "Started as the spoiled, cowardly son of Captain Morgan. After his father's defeat, he trained under Garp alongside Coby and grew into a capable Marine officer. He is a member of SWORD, the same secret unit as Coby and X. Drake. Wields kukri blades.",
    details: [
      "Son of Axe-Hand Morgan, the corrupt Marine Captain from Luffy's first adventure",
      "Trained under Garp alongside Coby",
      "Part of SWORD, the Marines' secret anti-pirate unit",
      "Went from a pathetic bully to a skilled fighter"
    ]
  },
  {
    slug: 'sentomaru',
    name: 'Sentomaru',
    aliases: ['The Most Guarded Man in the World'],
    crew: 'Marines / Science Division',
    role: 'Bodyguard of Vegapunk (former)',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/7/54823.jpg',
    bio: "The former bodyguard of Dr. Vegapunk and commander of the Pacifista units. He claims to have the strongest guard in the world. Uses a fighting style based on sumo that includes Haki-infused palm strikes. Despite his tough talk, he frequently blurts out information while insisting he won't say anything.",
    details: [
      "Commands the Marine's Pacifista army",
      "Can use Armament Haki — demonstrated it before the timeskip at Sabaody",
      "Played a role in the Egghead arc protecting Vegapunk"
    ]
  },
  {
    slug: 'vegapunk',
    name: 'Dr. Vegapunk',
    aliases: ['The Genius'],
    crew: 'World Government Science Division',
    role: 'Lead Scientist',
    devilFruit: 'Nomi Nomi no Mi (Brain-Brain Fruit)',
    devilFruitType: 'Paramecia',
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/6/503527.jpg',
    bio: "The greatest scientist in the One Piece world. Created the Pacifista, sea prism stone applications, artificial Devil Fruits, and the Seraphim. His Brain-Brain Fruit lets him store unlimited knowledge — his head once grew so large he had to cut parts of his brain out and store them in a separate location. He split himself into six satellite bodies, each representing a different aspect of his personality.",
    details: [
      "Created the Pacifista program, artificial Devil Fruits, and the Seraphim",
      "Split into 6 satellites: Shaka (good), Lilith (evil), Edison (thinking), Pythagoras (wisdom), Atlas (violence), York (greed)",
      "York betrayed him during the Egghead arc",
      "Central character of the Egghead arc where major world secrets were revealed"
    ]
  },
  {
    slug: 'jozu',
    name: 'Jozu',
    aliases: ['Diamond Jozu'],
    crew: 'Whitebeard Pirates',
    role: '3rd Division Commander',
    devilFruit: 'Kira Kira no Mi (Twinkle-Twinkle Fruit)',
    devilFruitType: 'Paramecia',
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/3/50454.jpg',
    bio: "The 3rd Division Commander of the Whitebeard Pirates. His Diamond Fruit lets him turn any part of his body into diamond, making him nearly indestructible. At Marineford, he picked up and threw a massive iceberg at the Marine forces. He lost his right arm to Aokiji when he was momentarily distracted by Ace's death.",
    details: [
      "Can turn his body into diamond — blocked a Mihawk slash without a scratch",
      "Threw an iceberg the size of a building at Marineford",
      "Lost his arm to Aokiji's ice powers during the war"
    ]
  },
  {
    slug: 'fisher-tiger',
    name: 'Fisher Tiger',
    aliases: ['Tiger the Adventurer'],
    crew: 'Sun Pirates',
    role: 'Captain / Founder',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: '230,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/8/162743.jpg',
    bio: "A sea bream fish-man who climbed the Red Line with his bare hands to free the slaves of Mariejois — fish-men, humans, and all races. He founded the Sun Pirates and branded their crew mark over former slaves' marks to hide their shame. Despite freeing human slaves alongside fish-men, he could never forgive humans for what was done to him. He died refusing a blood transfusion from humans.",
    details: [
      "Climbed the Red Line bare-handed to attack Mariejois and free the slaves",
      "Freed Boa Hancock, her sisters, and many others from slavery",
      "The Sun Pirates brand covers the Celestial Dragon slave mark",
      "Died from blood loss because no human would give blood to a fish-man, and he refused human blood"
    ]
  },
  {
    slug: 'kyros',
    name: 'Kyros',
    aliases: ['Thunder Soldier', 'Riku Family\'s Strongest'],
    crew: 'Riku Royal Army',
    role: 'Former Commander / Toy Soldier',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/2/274449.jpg',
    bio: "The legendary gladiator of Dressrosa who won 3,000 battles without taking a single hit. Sugar turned him into a toy soldier, erasing everyone's memory of him — including his own daughter Rebecca's. He spent 10 years as a toy, protecting Rebecca without her knowing he was her father. When Sugar was knocked out, he transformed back and immediately cut off Doflamingo's head (though it was a string clone).",
    details: [
      "Won 3,000 consecutive matches in the Corrida Colosseum without being hit once",
      "Spent 10 years as a toy soldier after Sugar transformed him",
      "Rebecca's father — she didn't remember him until Sugar's powers broke",
      "Cut Doflamingo's head off within seconds of transforming back (it was a string clone)"
    ]
  },
  {
    slug: 'senor-pink',
    name: 'Senor Pink',
    aliases: ['Hard-Boiled'],
    crew: 'Donquixote Pirates',
    role: 'Officer',
    devilFruit: 'Sui Sui no Mi (Swim-Swim Fruit)',
    devilFruitType: 'Paramecia',
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/16/235809.jpg',
    bio: "An officer of the Donquixote Pirates who dresses as a baby — bonnet, pacifier, diaper and all. Sounds absurd until you learn why: his wife Russian fell into a coma after discovering he was a pirate. The only time she smiled after that was when he wore their infant son's clothes. He kept wearing them for the rest of his life. His Swim-Swim Fruit lets him swim through solid ground. His fight with Franky is pure respect between two men.",
    details: [
      "Dresses as a baby because it was the only thing that made his comatose wife smile",
      "His backstory is considered one of the saddest in the Dressrosa arc",
      "Can swim through solid ground and walls like water",
      "His fight with Franky ended with mutual admiration — both called the other hard-boiled"
    ]
  },
  {
    slug: 'charlotte-smoothie',
    name: 'Charlotte Smoothie',
    aliases: [],
    crew: 'Big Mom Pirates',
    role: 'Sweet Commander, Minister of Juice',
    devilFruit: 'Shibo Shibo no Mi (Wring-Wring Fruit)',
    devilFruitType: 'Paramecia',
    bounty: '932,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/10/343042.jpg',
    bio: "One of Big Mom's three Sweet Commanders. Her Wring-Wring Fruit lets her squeeze liquid out of any living thing or object and absorb it to grow in size. Despite having one of the highest bounties in the series, she barely got any fight scenes — a long-running joke among fans.",
    details: [
      "Bounty of 932,000,000 berries",
      "One of the three Sweet Commanders alongside Katakuri and Cracker",
      "Can drain liquids from people, animals, and objects",
      "Grows larger as she absorbs more liquid"
    ]
  },
  {
    slug: 'charlotte-cracker',
    name: 'Charlotte Cracker',
    aliases: ['Thousand Arms'],
    crew: 'Big Mom Pirates',
    role: 'Sweet Commander, Minister of Biscuit',
    devilFruit: 'Bisu Bisu no Mi (Biscuit-Biscuit Fruit)',
    devilFruitType: 'Paramecia',
    bounty: '860,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/16/368448.jpg',
    bio: "One of Big Mom's three Sweet Commanders. His Biscuit-Biscuit Fruit creates biscuit soldiers so tough that even Luffy's Gear Fourth couldn't break them at first. He hides inside his biscuit armor — the 'Cracker' everyone knew was actually the armor, not him. Luffy only beat him by eating his biscuits faster than he could make them, with Nami softening them with rain.",
    details: [
      "Bounty of 860,000,000 berries",
      "Can create unlimited biscuit soldiers that are harder than steel",
      "His real face was hidden inside his armor — nobody knew what he looked like",
      "Luffy had to eat his way through the biscuit army to win"
    ]
  },
  {
    slug: 'dorry',
    name: 'Dorry',
    aliases: ['Blue Ogre'],
    crew: 'Giant Warrior Pirates',
    role: 'Co-Captain',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/15/596880.jpg',
    bio: "One of the two giant warrior captains from Elbaf who have been fighting each other on Little Garden for 100 years. He and Brogy fight every day to settle a forgotten argument. Their duel represents the giant warrior code of honor — they fight not out of hatred, but because their pride demands it.",
    details: [
      "Co-captain of the Giant Warrior Pirates alongside Brogy",
      "Has been dueling Brogy on Little Garden for over 100 years",
      "Neither giant remembers what started the fight"
    ]
  },
  {
    slug: 'brogy',
    name: 'Brogy',
    aliases: ['Red Ogre'],
    crew: 'Giant Warrior Pirates',
    role: 'Co-Captain',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/13/596879.jpg',
    bio: "The other half of the giant warrior captains from Elbaf. Together with Dorry, their combined attack 'Hakoku' can split anything in its path. After 100 years on Little Garden, both giants eventually left and returned to Elbaf. They reappeared in the story during the Egghead arc.",
    details: [
      "Co-captain of the Giant Warrior Pirates alongside Dorry",
      "Hakoku: their combined attack splits the sea",
      "Returned during the Egghead arc after 100+ years on Little Garden"
    ]
  },
  {
    slug: 'laboon',
    name: 'Laboon',
    aliases: [],
    crew: 'None',
    role: 'Island Whale',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/13/235377.jpg',
    bio: "An island whale who lives at the entrance to the Grand Line near Reverse Mountain. He has been waiting 50 years for Brook and the Rumbar Pirates to return. He bashes his head against the Red Line every day trying to reach them. Luffy painted the Straw Hat jolly roger on his head and promised they would come back — through the Grand Line, the long way around.",
    details: [
      "Has been waiting at Reverse Mountain for over 50 years",
      "Cared for by Crocus, Roger's former doctor",
      "The Straw Hat flag on his head is a promise from Luffy",
      "Brook's entire dream is to reunite with Laboon"
    ]
  },
  {
    slug: 'vinsmoke-reiju',
    name: 'Vinsmoke Reiju',
    aliases: ['Poison Pink'],
    crew: 'Germa 66',
    role: 'Commander / Eldest Child',
    devilFruit: 'None (Germa modifications)',
    devilFruitType: null,
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/6/343184.jpg',
    bio: "Sanji's older sister and the only Vinsmoke sibling who retained her emotions (like Sanji, thanks to their mother Sora's sacrifice). She helped Luffy by sucking poison out of his body at Whole Cake Island. Despite being kind, she stayed with Germa because she felt she had no choice.",
    details: [
      "The only other Vinsmoke child with emotions, besides Sanji",
      "Can absorb and redirect poison",
      "Secretly helped Sanji and Luffy during the Whole Cake Island arc",
      "Wears the pink Raid Suit of Germa 66"
    ]
  },
  {
    slug: 'vinsmoke-judge',
    name: 'Vinsmoke Judge',
    aliases: ['Garuda'],
    crew: 'Germa 66',
    role: 'King of the Germa Kingdom / Commander',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/4/340284.jpg',
    bio: "Sanji's father and king of the Germa Kingdom. A brilliant scientist who genetically modified his own children to be emotionless super soldiers. He considered Sanji a failure because the modifications didn't work on him. Arranged Sanji's marriage to Big Mom's daughter Pudding as a political alliance — not knowing Big Mom planned to kill the entire Vinsmoke family at the wedding.",
    details: [
      "Modified his children's genes before birth to create super soldiers",
      "Considered Sanji worthless because Sanji kept his emotions",
      "His wife Sora took a counter-drug to save Sanji's humanity, at the cost of her health",
      "Was saved by Sanji at the wedding despite how he treated him"
    ]
  },
  {
    slug: 'kurozumi-orochi',
    name: 'Kurozumi Orochi',
    aliases: [],
    crew: 'Kurozumi Clan',
    role: 'Former Shogun of Wano',
    devilFruit: 'Hebi Hebi no Mi, Model: Yamata no Orochi (Snake-Snake Fruit)',
    devilFruitType: 'Mythical Zoan',
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/13/401502.jpg',
    bio: "The corrupt Shogun who ruled Wano alongside Kaido for 20 years. His Mythical Zoan fruit gives him eight serpent heads — each time one is cut off, he survives. A coward who used Kaido's protection to oppress the people of Wano. His family, the Kurozumi clan, was persecuted for a previous generation's crimes, which fueled his desire for revenge.",
    details: [
      "Ruled Wano as a puppet shogun under Kaido's protection",
      "His eight-headed serpent form lets him survive decapitation multiple times",
      "Poisoned Kozuki Oden's father to take the shogunate",
      "Finally killed by Denjiro during the Wano raid"
    ]
  },
  {
    slug: 'caribou',
    name: 'Caribou',
    aliases: ['Wet-Haired'],
    crew: 'Caribou Pirates',
    role: 'Captain',
    devilFruit: 'Numa Numa no Mi (Swamp-Swamp Fruit)',
    devilFruitType: 'Logia',
    bounty: '210,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/11/193145.jpg',
    bio: "A swamp Logia user and recurring minor villain. His Swamp-Swamp Fruit turns him into a bottomless swamp that can store anything inside his body. He overheard that Shirahoshi is the ancient weapon Poseidon and has been trying to sell that information ever since. He kept showing up in Wano and Egghead after being dragged along involuntarily.",
    details: [
      "Knows that Shirahoshi is the ancient weapon Poseidon",
      "Can store objects and people inside his swamp body indefinitely",
      "Keeps getting dragged into Straw Hat adventures against his will"
    ]
  },
  {
    slug: 'pekoms',
    name: 'Pekoms',
    aliases: [],
    crew: 'Big Mom Pirates',
    role: 'Combatant',
    devilFruit: 'Kame Kame no Mi (Turtle-Turtle Fruit)',
    devilFruitType: 'Zoan',
    bounty: '330,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/2/193151.jpg',
    bio: "A lion mink who is a member of the Big Mom Pirates. His Turtle-Turtle Fruit gives him a hard shell for defense. He is from Zou and feels loyalty to both Big Mom and his homeland. He helped Luffy at Whole Cake Island because the Straw Hats saved Zou from Jack's attack.",
    details: [
      "A lion mink with a turtle Devil Fruit — unusual combination",
      "Helped Luffy out of gratitude for saving Zou",
      "Shot by Bege for trying to let the Straw Hats escape"
    ]
  },
  {
    slug: 'gan-fall',
    name: 'Gan Fall',
    aliases: ['Knight of the Sky'],
    crew: 'Skypiea',
    role: 'Former God of Skypiea',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/13/54687.jpg',
    bio: "The former God (ruler) of Skypiea before Enel took over. A kind old knight who rides a flying horse named Pierre. He helped the Straw Hats navigate Skypiea and fought alongside them against Enel's forces. After Enel's defeat, he returned as God of Skypiea.",
    details: [
      "Rides Pierre, a bird that ate the Horse-Horse Fruit (turning into a pegasus)",
      "Fought to protect both the Skypieans and the Shandians",
      "Returned as God of Skypiea after Enel left for the moon"
    ]
  },
  {
    slug: 'wiper',
    name: 'Wiper',
    aliases: ['The Berserker'],
    crew: 'Shandian Warriors',
    role: 'Warrior / Leader',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/9/91661.jpg',
    bio: "The fiercest warrior of the Shandian tribe in Skypiea. A descendant of Calgara who fought for 400 years to reclaim the Shandians' homeland from the Skypieans. Used Reject Dials that deal massive damage but nearly kill the user with each shot. He temporarily took down Enel using a sea prism stone-tipped attack.",
    details: [
      "Descendant of the great warrior Calgara",
      "Used Reject Dials — weapons that reflect damage back at 10x the power, at the cost of the user's body",
      "Hit Enel with a sea prism stone, temporarily negating his lightning powers",
      "Reconciled with the Skypieans after Enel's defeat"
    ]
  },
  {
    slug: 'calgara',
    name: 'Calgara',
    aliases: ['The Great Warrior'],
    crew: 'Shandian Warriors',
    role: 'Warrior / Chief',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/3/54694.jpg',
    bio: "The great Shandian warrior from 400 years ago who befriended the explorer Montblanc Noland. Their friendship bridged the gap between their peoples until a misunderstanding tore it apart. When the Knock Up Stream launched half of Jaya into the sky, Calgara and the Shandians were sent to Skypiea. He rang the golden bell to signal Noland, but Noland arrived to find the island gone.",
    details: [
      "Best friend of Montblanc Noland the explorer",
      "Their story is the emotional backbone of the Skypiea arc",
      "Rang the Golden Bell of Shandora to guide Noland back",
      "Wiper is his descendant, 400 years later"
    ]
  },
  {
    slug: 'galdino',
    name: 'Galdino',
    aliases: ['Mr. 3'],
    crew: 'Baroque Works (former) / Buggy Pirates',
    role: 'Agent (former)',
    devilFruit: 'Doru Doru no Mi (Wax-Wax Fruit)',
    devilFruitType: 'Paramecia',
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/5/56861.jpg',
    bio: "Mr. 3 of Baroque Works. His Wax-Wax Fruit lets him create and control wax that hardens like steel. Originally a villain in the Little Garden arc, he ended up helping Luffy escape Impel Down. His wax was the key to freeing Ace's sea prism stone handcuffs at Marineford. Now a member of Buggy's crew.",
    details: [
      "His hardened wax key freed Ace's handcuffs at Marineford",
      "Helped Luffy, Bon Clay, and others escape Impel Down",
      "Now follows Buggy, likely part of Cross Guild",
      "His wax can block poison and create weapons"
    ]
  },
  {
    slug: 'jabra',
    name: 'Jabra',
    aliases: [],
    crew: 'CP9',
    role: 'Agent',
    devilFruit: 'Inu Inu no Mi, Model: Wolf (Dog-Dog Fruit)',
    devilFruitType: 'Zoan',
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/5/71510.jpg',
    bio: "A member of CP9 with a wolf Zoan fruit. A skilled liar and manipulator who tried to trick Sanji by pretending to cry. His Tekkai Kenpo fighting style combines the iron body technique with martial arts, letting him attack while maintaining his steel-hard defense. Fought Sanji at Enies Lobby.",
    details: [
      "Can combine Tekkai (Iron Body) with offensive attacks — something other CP9 agents can't do",
      "Tried to manipulate Sanji with a fake sob story about Robin being his sister",
      "Defeated by Sanji's Diable Jambe at Enies Lobby"
    ]
  },
  {
    slug: 'kalifa',
    name: 'Kalifa',
    aliases: [],
    crew: 'CP9',
    role: 'Agent',
    devilFruit: 'Awa Awa no Mi (Bubble-Bubble Fruit)',
    devilFruitType: 'Paramecia',
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/4/72897.jpg',
    bio: "A member of CP9 who went undercover as Iceburg's secretary at Galley-La for five years. Her Bubble-Bubble Fruit creates soap bubbles that clean anything they touch — including a person's strength, making their body slippery and weak. Defeated by Nami at Enies Lobby.",
    details: [
      "Undercover as Iceburg's secretary for five years",
      "Her bubbles drain physical strength from anyone they touch",
      "Defeated by Nami using her Clima-Tact's thunder attacks",
      "Frequently says 'that's sexual harassment' to deflect questions"
    ]
  },
  {
    slug: 'kumadori',
    name: 'Kumadori',
    aliases: [],
    crew: 'CP9',
    role: 'Agent',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/16/71511.jpg',
    bio: "A member of CP9 who fights with his hair using a technique called Life Return, which lets him control his body at the cellular level — making his hair move like tentacles. Speaks and acts like a kabuki performer. Constantly tries to commit ritual suicide over minor things but his Iron Body technique keeps him alive.",
    details: [
      "Controls his hair like extra limbs using Life Return",
      "Fights in a kabuki style with dramatic poses and speeches",
      "Fought Chopper at Enies Lobby — Chopper used Monster Point for the first time",
      "Keeps trying to kill himself out of dramatic shame but his own Tekkai prevents it"
    ]
  },
  {
    slug: 'ulti',
    name: 'Ulti',
    aliases: [],
    crew: 'Beasts Pirates',
    role: 'Tobiroppo (Flying Six)',
    devilFruit: 'Ryu Ryu no Mi, Model: Pachycephalosaurus (Dragon-Dragon Fruit)',
    devilFruitType: 'Ancient Zoan',
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/8/453421.jpg',
    bio: "One of the Tobiroppo (Flying Six) in Kaido's crew. Her Ancient Zoan fruit turns her into a Pachycephalosaurus — she attacks with devastating headbutts. Fiercely protective of her younger brother Page One. She fought Nami during the Wano raid and was taken down by Big Mom's attack.",
    details: [
      "Her headbutts are strong enough to crack Luffy's skull",
      "Extremely protective of her brother Page One",
      "Fought both Luffy and Yamato during the raid on Onigashima",
      "Knocked out by Big Mom's lightning attack meant for Nami"
    ]
  },
  {
    slug: 'page-one',
    name: 'Page One',
    aliases: [],
    crew: 'Beasts Pirates',
    role: 'Tobiroppo (Flying Six)',
    devilFruit: 'Ryu Ryu no Mi, Model: Spinosaurus (Dragon-Dragon Fruit)',
    devilFruitType: 'Ancient Zoan',
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/11/476813.jpg',
    bio: "One of the Tobiroppo (Flying Six) in Kaido's crew and Ulti's younger brother. His Ancient Zoan fruit turns him into a Spinosaurus. He was the first member of the Flying Six to fight a Straw Hat — Sanji used the Raid Suit against him in Wano.",
    details: [
      "Ulti's younger brother",
      "Fought Sanji when Sanji first used the Raid Suit",
      "Defeated by Big Mom during the Wano raid"
    ]
  },
  {
    slug: 'black-maria',
    name: 'Black Maria',
    aliases: [],
    crew: 'Beasts Pirates',
    role: 'Tobiroppo (Flying Six)',
    devilFruit: 'Kumo Kumo no Mi, Model: Rosamygale Grauvogeli (Spider-Spider Fruit)',
    devilFruitType: 'Ancient Zoan',
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/8/453098.jpg',
    bio: "One of the Tobiroppo (Flying Six) in Kaido's crew. Her Ancient Zoan fruit turns her into a prehistoric spider. She trapped Sanji in her web knowing he wouldn't fight a woman, then used him as bait to capture Robin. Robin defeated her using her Demonio Fleur giant demon form — Robin's biggest power reveal in years.",
    details: [
      "Used Sanji's refusal to fight women against him",
      "Defeated by Robin's Demonio Fleur — a giant dark demon form",
      "Her spider web is laced with adhesive and hallucinogens",
      "Robin's fight against her was Robin's first real solo battle in years"
    ]
  },
  {
    slug: 'nekomamushi',
    name: 'Nekomamushi',
    aliases: ['Cat Viper', 'Ruler of Night'],
    crew: 'Mokomo Dukedom / Nine Red Scabbards',
    role: 'Ruler of Night',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/13/314725.jpg',
    bio: "A cat mink and one of the two rulers of the Mokomo Dukedom on Zou. He rules during the night while Inuarashi rules during the day. He is one of Kozuki Oden's Nine Red Scabbards. A former member of both the Whitebeard Pirates and the Roger Pirates, having sailed with Oden.",
    details: [
      "One of the Nine Red Scabbards who served Kozuki Oden",
      "Sailed with both Whitebeard and Roger as part of Oden's retainers",
      "Sulong form gives him immense power under the full moon",
      "His rivalry with Inuarashi goes back to Oden's death — they blamed each other for not saving him"
    ]
  },
  {
    slug: 'inuarashi',
    name: 'Inuarashi',
    aliases: ['Dogstorm', 'Ruler of Day'],
    crew: 'Mokomo Dukedom / Nine Red Scabbards',
    role: 'Ruler of Day',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/4/313120.jpg',
    bio: "A dog mink and one of the two rulers of the Mokomo Dukedom on Zou. He rules during the day. One of Kozuki Oden's Nine Red Scabbards who traveled back from the past to avenge their lord. A master swordsman who fought Jack the Drought evenly despite having one leg.",
    details: [
      "One of the Nine Red Scabbards",
      "Fought Jack for five straight days while defending Zou",
      "Lost a leg during Jack's attack on Zou but kept fighting",
      "Sulong form makes him one of the strongest fighters on Zou"
    ]
  },
  {
    slug: 'kawamatsu',
    name: 'Kawamatsu',
    aliases: ['Kawamatsu the Kappa'],
    crew: 'Nine Red Scabbards / Kozuki Clan',
    role: 'Scabbard',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/7/400879.jpg',
    bio: "A kappa-like fish-man and one of the Nine Red Scabbards. He was imprisoned in Udon for 13 years after Oden's death, surviving by eating poisoned fish meant to kill him. He hoarded weapons in secret during his imprisonment, preparing for the day someone would rise against Kaido.",
    details: [
      "Survived 13 years in prison eating poisoned fish — his fish-man body resisted the poison",
      "Stockpiled weapons in Ringo for the eventual rebellion",
      "Uses a sumo-based fighting style combined with swordsmanship",
      "Protected Kozuki Hiyori (Komurasaki) after Oden's death"
    ]
  },
  {
    slug: 'trebol',
    name: 'Trebol',
    aliases: [],
    crew: 'Donquixote Pirates',
    role: 'Special Officer / Club Seat',
    devilFruit: 'Beta Beta no Mi (Sticky-Sticky Fruit)',
    devilFruitType: 'Paramecia',
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/4/237209.jpg',
    bio: "One of Doflamingo's top three officers. His Sticky-Sticky Fruit covers him in thick mucus that is extremely flammable. He was the one who found young Doflamingo as a child and gave him the String-String Fruit, setting him on the path to become a tyrant. He acts like a fool but is ruthless underneath.",
    details: [
      "Found Doflamingo as a child and gave him his Devil Fruit and a gun",
      "Has been with Doflamingo since the very beginning",
      "His mucus is highly flammable — Law used this against him",
      "Defeated by Law during the Dressrosa arc"
    ]
  },
  {
    slug: 'pica',
    name: 'Pica',
    aliases: [],
    crew: 'Donquixote Pirates',
    role: 'Top Officer / Spade Seat',
    devilFruit: 'Ishi Ishi no Mi (Stone-Stone Fruit)',
    devilFruitType: 'Paramecia',
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/8/278183.jpg',
    bio: "One of Doflamingo's top officers. His Stone-Stone Fruit lets him merge with and control stone — he absorbed all of Dressrosa's stone structures to become a giant the size of a mountain. Despite his enormous body, he has a very high-pitched voice which he is extremely sensitive about. Zoro cut him down in one of the most satisfying attacks in the arc.",
    details: [
      "Can merge with stone and grow to the size of a mountain",
      "Has a squeaky high-pitched voice — will attack anyone who laughs at it",
      "Defeated by Zoro with a single massive slash that cut through his stone giant form"
    ]
  },
  {
    slug: 'vergo',
    name: 'Vergo',
    aliases: ['Demon Bamboo'],
    crew: 'Donquixote Pirates / Marines (undercover)',
    role: 'Agent / Vice Admiral (undercover)',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/7/235831.jpg',
    bio: "Doflamingo's first and most loyal follower who infiltrated the Marines and rose to the rank of Vice Admiral. He was the secret commander of G-5 Marine Base. His full-body Armament Haki was so strong his entire body turned black. Law cut him in half on Punk Hazard — literally.",
    details: [
      "Doflamingo's first crew member and the original Corazon (Heart Seat)",
      "Infiltrated the Marines and became a Vice Admiral — a mole for decades",
      "Full-body Armament Haki made him nearly indestructible",
      "Cut in half by Law's Room ability on Punk Hazard",
      "Always had food stuck to his face without noticing"
    ]
  },
  {
    slug: 'baby-5',
    name: 'Baby 5',
    aliases: [],
    crew: 'Donquixote Pirates (former)',
    role: 'Officer',
    devilFruit: 'Buki Buki no Mi (Arms-Arms Fruit)',
    devilFruitType: 'Paramecia',
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/11/235839.jpg',
    bio: "A former officer of the Donquixote Pirates. Her Arms-Arms Fruit lets her transform any part of her body into a weapon — swords, guns, missiles, even a full cannon. She has a compulsion to agree to anyone who says they need her, because she was abandoned as a child. She married Sai of the Happo Navy after the Dressrosa arc.",
    details: [
      "Can turn her body into any weapon including missiles and swords",
      "Cannot refuse anyone who says 'I need you' due to childhood abandonment",
      "Married Sai of the Happo Navy after Dressrosa",
      "Doflamingo manipulated her need to be needed for years"
    ]
  },
  {
    slug: 'dellinger',
    name: 'Dellinger',
    aliases: [],
    crew: 'Donquixote Pirates',
    role: 'Officer',
    devilFruit: 'None (half fighting fish fish-man)',
    devilFruitType: null,
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/12/260481.jpg',
    bio: "An officer of the Donquixote Pirates who is half fighting fish fish-man. He was raised by the Donquixote Family since he was a baby. Extremely fast and vicious in combat, using his fish-man heritage to deliver powerful kicks with his horns. Defeated by Hakuba (Cavendish's alter ego).",
    details: [
      "Half fish-man — has horns from his fighting fish heritage",
      "Raised by the Donquixote Family from infancy",
      "Defeated by Hakuba's lightning-fast sword attacks"
    ]
  },
  {
    slug: 'hogback',
    name: 'Dr. Hogback',
    aliases: [],
    crew: 'Thriller Bark',
    role: 'Scientist under Gecko Moria',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/11/50257.jpg',
    bio: "A genius surgeon who joined Gecko Moria to revive the dead. He modifies corpses and Moria fills them with stolen shadows to create zombie soldiers. He was once a famous doctor but abandoned medicine for necromancy. He created many of Thriller Bark's zombies, including the General Zombies.",
    details: [
      "Was once a famous surgeon admired worldwide",
      "Turned to necromancy to revive his dead love, Victoria Cindry",
      "Created the zombie army of Thriller Bark by surgically combining corpses"
    ]
  },
  {
    slug: 'oars',
    name: 'Oars',
    aliases: ['Continent Puller'],
    crew: 'Thriller Bark (zombie)',
    role: 'Special Zombie',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/12/55065.jpg',
    bio: "A giant from 500 years ago known as 'The Continent Puller' because he literally dragged continents across the sea. Moria stuffed Luffy's shadow into Oars' frozen corpse, creating a zombie with Luffy's personality and fighting style but in a body the size of a mountain. It took the entire Straw Hat crew working together to bring him down.",
    details: [
      "His corpse was brought back by Moria using Luffy's shadow",
      "Used Luffy's fighting techniques in a body the size of an island",
      "The entire Straw Hat crew had to fight together to defeat him",
      "His descendant Little Oars Jr. appeared at Marineford"
    ]
  },
  {
    slug: 'hannyabal',
    name: 'Hannyabal',
    aliases: [],
    crew: 'Impel Down',
    role: 'Vice Warden (now Warden)',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/9/68592.jpg',
    bio: "The former Vice Warden of Impel Down who constantly plotted to take Magellan's job. Despite being comedically ambitious, he showed genuine bravery when he stood against Luffy and the escaped prisoners alone, giving a speech about how releasing criminals would hurt innocent people. He was promoted to Warden after Magellan was demoted.",
    details: [
      "Constantly schemes to replace Magellan as Warden (and eventually does)",
      "Stood alone against Luffy and the escapees to protect the outside world",
      "His speech about protecting innocent people from criminals is one of the most respected villain moments",
      "Became Warden after the mass breakout"
    ]
  },
  {
    slug: 'koala',
    name: 'Koala',
    aliases: [],
    crew: 'Revolutionary Army',
    role: 'Fish-Man Karate Instructor',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/3/192601.jpg',
    bio: "A member of the Revolutionary Army and close partner of Sabo. As a child, she was a slave of the Celestial Dragons until Fisher Tiger freed her during his raid on Mariejois. The Sun Pirates returned her to her home island. She later joined the Revolutionary Army and learned Fish-Man Karate despite being human.",
    details: [
      "Former slave freed by Fisher Tiger during his raid on Mariejois",
      "Works alongside Sabo in the Revolutionary Army",
      "Practices Fish-Man Karate despite being human",
      "Appeared at Dressrosa helping Sabo during the Colosseum"
    ]
  },
  {
    slug: 'belo-betty',
    name: 'Belo Betty',
    aliases: [],
    crew: 'Revolutionary Army',
    role: 'Commander, East Army',
    devilFruit: 'Kobu Kobu no Mi (Pump-Pump Fruit)',
    devilFruitType: 'Paramecia',
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/9/377108.jpg',
    bio: "Commander of the Revolutionary Army's East Army. Her Pump-Pump Fruit lets her inspire people so intensely that their physical strength actually increases. She rallies oppressed civilians into fighting back against their oppressors by boosting their courage and power through motivational speeches.",
    details: [
      "Her Devil Fruit literally makes people stronger through inspiration",
      "Commands the Eastern forces of the Revolutionary Army",
      "Appeared during the Reverie arc rallying civilians against pirates"
    ]
  },
  {
    slug: 'squard',
    name: 'Squard',
    aliases: ['Maelstrom Spider'],
    crew: 'Maelstrom Spider Pirates',
    role: 'Captain / Whitebeard Ally',
    devilFruit: 'None',
    devilFruitType: null,
    bounty: null,
    image: 'https://cdn.myanimelist.net/images/characters/7/100670.jpg',
    bio: "An allied captain under Whitebeard who was manipulated by Akainu into stabbing Whitebeard at Marineford. Akainu told him that Whitebeard made a deal with the Marines to spare the Straw Hats (because Luffy is the son of Roger, who killed Squard's old crew). Whitebeard forgave him immediately and hugged him.",
    details: [
      "Stabbed Whitebeard after Akainu manipulated him",
      "Roger killed his original crew, so Akainu used his hatred of Roger to turn him against Whitebeard",
      "Whitebeard forgave him on the spot — 'You are my son'"
    ]
  },
  {
    slug: 'kaido',
    name: 'Kaido',
    aliases: ['King of the Beasts', 'The Strongest Creature'],
    crew: 'Beasts Pirates',
    role: 'Governor-General / Former Emperor',
    devilFruit: 'Uo Uo no Mi, Model: Seiryu (Fish-Fish Fruit, Model: Azure Dragon)',
    devilFruitType: 'Mythical Zoan',
    bounty: '4,611,100,000',
    image: '/characters/kaido.webp',
    bio: "Known as the Strongest Creature in the world. One of the Four Emperors who ruled Wano for 20 years alongside the puppet shogun Orochi after killing Kozuki Oden. His Mythical Zoan fruit turns him into a massive Azure Dragon that can fly, breathe fire, and create lightning. He tried to kill himself multiple times out of boredom because nothing could hurt him. Luffy needed Gear Fifth to finally bring him down.",
    details: [
      "Bounty of 4,611,100,000 berries",
      "Killed Kozuki Oden after Oden was tricked during their duel",
      "The only person Oden ever scarred — the scar on his body is from Oden's sword",
      "Defeated Luffy three times before Luffy beat him with Gear Fifth",
      "Wanted to start the biggest war the world has ever seen",
      "Former member of the Rocks Pirates alongside Big Mom, Whitebeard, and Shiki"
    ]
  },
  {
    slug: 'yamato',
    name: 'Yamato',
    aliases: ['Oni Princess', 'Self-proclaimed Kozuki Oden'],
    crew: 'None (ally of the Straw Hats)',
    role: "Kaido's Child",
    devilFruit: 'Inu Inu no Mi, Model: Okuchi no Makami (Dog-Dog Fruit, Model: Guardian Wolf Deity)',
    devilFruitType: 'Mythical Zoan',
    bounty: null,
    image: '/characters/yamato.webp',
    bio: "Kaido's child who witnessed Kozuki Oden's execution as a kid and decided to become Oden — literally taking his name, his fighting style, and his dream. Kaido chained Yamato up and blew up the island's bridges to keep them imprisoned on Onigashima. Yamato fought alongside Luffy during the raid and held Kaido off alone while Luffy recovered.",
    details: [
      "Ate a Mythical Zoan fruit: the Guardian Wolf Deity of Wano",
      "Can use all three types of Haki including Conqueror's Haki",
      "Kept Oden's logbook (his journal from the Roger Pirates voyage)",
      "Held Kaido in a 1v1 fight to buy time for Luffy",
      "Chose to stay in Wano instead of joining the Straw Hats, to protect it like Oden wanted"
    ]
  },
  {
    slug: 'king-alber',
    name: 'King',
    aliases: ['King the Wildfire', 'Alber'],
    crew: 'Beasts Pirates',
    role: 'All-Star (1st Commander)',
    devilFruit: 'Ryu Ryu no Mi, Model: Pteranodon (Dragon-Dragon Fruit)',
    devilFruitType: 'Ancient Zoan',
    bounty: '1,390,000,000',
    image: '/characters/king.webp',
    bio: "Kaido's right-hand man and the strongest of the three All-Stars. A member of the Lunarian race — a nearly extinct people who lived on top of the Red Line before the Celestial Dragons took it. His Lunarian heritage lets him create and control fire. The World Government offered anyone who reported a Lunarian 100 million berries. Defeated by Zoro using Advanced Conqueror's Haki.",
    details: [
      "Bounty of 1,390,000,000 berries",
      "Last known Lunarian — a race the World Government tried to erase",
      "His real name is Alber — Kaido gave him the name King",
      "Defeated by Zoro using Enma and King of Hell Three Sword Style"
    ]
  },
  {
    slug: 'queen-plague',
    name: 'Queen',
    aliases: ['Queen the Plague'],
    crew: 'Beasts Pirates',
    role: 'All-Star (2nd Commander)',
    devilFruit: 'Ryu Ryu no Mi, Model: Brachiosaurus (Dragon-Dragon Fruit)',
    devilFruitType: 'Ancient Zoan',
    bounty: '1,320,000,000',
    image: '/characters/queen.webp',
    bio: "One of Kaido's three All-Stars. A former scientist who worked alongside Vegapunk and Judge in the illegal research group MADS. Modified his own body with mechanical weapons — lasers, extendable neck, detachable limbs. Created plague-based weapons. Defeated by Sanji after Sanji's Germa modifications awakened.",
    details: [
      "Bounty of 1,320,000,000 berries",
      "Former colleague of Vegapunk and Vinsmoke Judge in the MADS science group",
      "Created the Ice Oni virus that turned people into frozen monsters during the raid",
      "Defeated by Sanji's Ifrit Jambe after Sanji's exoskeleton awakened"
    ]
  },
  {
    slug: 'jack-drought',
    name: 'Jack',
    aliases: ['Jack the Drought'],
    crew: 'Beasts Pirates',
    role: 'All-Star (3rd Commander)',
    devilFruit: 'Zou Zou no Mi, Model: Mammoth (Elephant-Elephant Fruit)',
    devilFruitType: 'Ancient Zoan',
    bounty: '1,000,000,000',
    image: '/characters/jack.webp',
    bio: "The weakest of Kaido's three All-Stars but still a monster with a billion-berry bounty. A fish-man who ate the Mammoth Ancient Zoan. He attacked Zou and tortured the Minks for days trying to find Raizo. Also attempted to rescue Doflamingo from the Marine convoy — and attacked a fleet that included Fujitora and Sengoku.",
    details: [
      "Bounty of 1,000,000,000 berries",
      "Tortured the Mink tribe on Zou using Caesar's poison gas",
      "Is a fish-man, which is why he survived underwater after being knocked off Zunisha",
      "Defeated by Inuarashi's Sulong form during the Wano raid"
    ]
  },
  {
    slug: 'gecko-moria',
    name: 'Gecko Moria',
    aliases: ['Master of Shadows'],
    crew: 'Thriller Bark / Former Warlord',
    role: 'Captain',
    devilFruit: 'Kage Kage no Mi (Shadow-Shadow Fruit)',
    devilFruitType: 'Paramecia',
    bounty: '320,000,000',
    image: '/characters/gecko-moria.webp',
    bio: "A former Warlord of the Sea and the main villain of the Thriller Bark arc. His Shadow-Shadow Fruit lets him steal people's shadows and put them into corpses to create zombie soldiers. He lost his entire crew to Kaido in the New World years ago, which broke him — he decided to build an undead army instead of recruiting living people. The World Government tried to have him killed at Marineford to cover up the war's chaos.",
    details: [
      "His entire original crew was wiped out by Kaido",
      "Created a zombie army on Thriller Bark using stolen shadows",
      "Put Luffy's shadow into the giant Oars",
      "The government ordered Doflamingo to kill him after Marineford — he survived",
      "Last seen on Blackbeard's island Hachinosu"
    ]
  },
  {
    slug: 'sengoku',
    name: 'Sengoku',
    aliases: ['Sengoku the Buddha'],
    crew: 'Marines',
    role: 'Former Fleet Admiral / Inspector General',
    devilFruit: 'Hito Hito no Mi, Model: Daibutsu (Human-Human Fruit, Model: Buddha)',
    devilFruitType: 'Mythical Zoan',
    bounty: null,
    image: '/characters/sengoku.webp',
    bio: "The former Fleet Admiral of the Marines who led the World Government's forces during the Marineford War. His Mythical Zoan fruit lets him transform into a giant golden Buddha that releases devastating shockwaves. He stepped down after the war and was replaced by Akainu. Now serves as Inspector General. One of the few Marines who knew Gol D. Roger personally.",
    details: [
      "Led the Marines during the Marineford War against Whitebeard",
      "Stepped down as Fleet Admiral after the war — Akainu replaced him",
      "His Buddha form generates massive Haki shockwaves",
      "Adopted Donquixote Rosinante (Corazon) and sent him to spy on Doflamingo",
      "One of the few people who knew about Ace being Roger's son"
    ]
  },
  {
    slug: 'marco',
    name: 'Marco',
    aliases: ['Marco the Phoenix'],
    crew: 'Whitebeard Pirates',
    role: '1st Division Commander',
    devilFruit: 'Tori Tori no Mi, Model: Phoenix (Bird-Bird Fruit)',
    devilFruitType: 'Mythical Zoan',
    bounty: null,
    image: '/characters/marco.webp',
    bio: "The First Division Commander of the Whitebeard Pirates and Whitebeard's right-hand man. His Phoenix Fruit lets him transform into a blue phoenix with regenerative flames that heal any wound. After Whitebeard died, Marco led the remnants in the Payback War against Blackbeard — and lost. He returned to fight alongside the Straw Hats during the Wano raid.",
    details: [
      "His blue flames heal wounds instead of burning — he can regenerate from almost anything",
      "Fought Admiral Kizaru, Akainu, and Big Mom at different points",
      "Led the Whitebeard Pirates after Whitebeard's death",
      "Worked as a doctor on Sphinx, Whitebeard's home island",
      "Fought King and Queen simultaneously during the Wano raid"
    ]
  },
  {
    slug: 'killer',
    name: 'Killer',
    aliases: ['Massacre Soldier'],
    crew: 'Kid Pirates',
    role: 'First Mate',
    devilFruit: 'SMILE (defective, forced)',
    devilFruitType: 'Artificial Zoan (defective)',
    bounty: '200,000,000',
    image: '/characters/killer.webp',
    bio: "The first mate of the Kid Pirates and one of the Eleven Supernovas — the only non-captain among them. Always wears a mask because he was bullied for his laugh as a child. In Wano, Orochi forced him to eat a defective SMILE fruit, which took away his ability to express any emotion except laughter.",
    details: [
      "One of the Worst Generation — the only supernova who isn't a captain",
      "Uses spinning scythe blades called Punishers",
      "Forced to eat a defective SMILE fruit in Wano — can only laugh now",
      "Fought on the rooftop of Onigashima against Kaido and Big Mom",
      "Kid's childhood friend and lifelong partner"
    ]
  },
];

export default characterProfiles;
